/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  const nav = document.querySelector(".header-scroll-visible");
  const header = document.querySelector(".nili-header-container");
  let lastScrollY = window.scrollY;
  let lastFocusedElement = null;

  window.addEventListener("scroll", () => {
    if (window.scrollY > 100) {
      if (lastScrollY < window.scrollY && Math.sign(lastScrollY) !== -1) {
        header.classList.add('stick-on-scroll-down');
        header.classList.remove('stick-on-scroll-top');
      } else {
        header.classList.remove('stick-on-scroll-down');
        header.classList.add('stick-on-scroll-top');
      }
    }
    lastScrollY = window.scrollY;
  });

  // Watch for tabbing direction
  document.addEventListener("keydown", (e) => {
    if (e.key === "Tab") {
      requestAnimationFrame(() => {
        const activeEl = document.activeElement;

        // If header is hidden and we're tabbing up (to a higher-up element)
        if (
          header.classList.contains('stick-on-scroll-down') &&
          lastFocusedElement &&
          activeEl.compareDocumentPosition(lastFocusedElement) & Node.DOCUMENT_POSITION_PRECEDING
        ) {
          header.classList.remove('stick-on-scroll-down');
          header.classList.add('stick-on-scroll-top');
        }

        lastFocusedElement = activeEl;
      });
    }
  });

  // Hide asterisk-only items depending on nav mode
  const headerWrapper = document.querySelector('[data-header-wrapper]');
  const navMode = headerWrapper && headerWrapper.getAttribute('data-nav-mode');
  if (navMode === 'mega' || navMode === 'standard') {
    const el = [...document.getElementsByClassName("navlink"), ...document.getElementsByClassName("sliderule__wrapper")];
    for (let i = 0; i < el.length; i++) {
      if (el[i].textContent.trim() === "*") {
        if (navMode === 'mega') {
          el[i].style.setProperty("display", "none", "important");
        } else {
          el[i].style.setProperty("visibility", "hidden", "important");
        }
      }
    }
  }

    
  if(document.getElementById('mobile-filter-result-show-btn')) {
    document.getElementById('mobile-filter-result-show-btn').addEventListener('click', function() {
      document.getElementById('mobile-filter-result-show-btn').classList.add('displayNone');
      document.getElementById('filter-clear-btn').classList.remove('displayNone');
    });
  } 
  
  /*---- Mobile Nav Customization ----*/
  if($(".sliderow").length) {
    $(".sliderow").on('click', function() {
      $(this).toggleClass('sub-menu-opened');
      const $dropdown = $(this).siblings('.mobile__menu__dropdown').first();
      $dropdown.children('.sliderow__links').toggleClass('hide');
    });
  }
  /*---- Ends Mobile Nav Customization ----*/

  /*---- Start: Keyboard navigation support ----*/
  function initMainNavigationKeyboardSupport() {
    const topMenuItems = document.querySelectorAll('.menu__item[aria-haspopup="true"], .top_menu_hoverable');
    
    topMenuItems.forEach(menuItem => {
      if (menuItem.getAttribute('tabindex')) {
        menuItem.removeAttribute('tabindex');
      }
      
      const topLink = menuItem.querySelector('a.navlink--toplevel');
      if (topLink) {
        if (!topLink.getAttribute('tabindex')) {
          topLink.setAttribute('tabindex', '0');
        }
        
        topLink.addEventListener('keydown', function(event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.click();
            
            const parentItem = this.closest('.menu__item[aria-haspopup="true"]');
            if (parentItem) {
              const isExpanded = parentItem.getAttribute('aria-expanded') === 'true';
              const dropdownId = parentItem.getAttribute('aria-controls');
              const dropdown = document.getElementById(dropdownId);
              
              parentItem.setAttribute('aria-expanded', !isExpanded);
              
              if (dropdown) {
                dropdown.style.display = !isExpanded ? 'block' : 'none';
                
                if (!isExpanded) {
                  const firstLink = dropdown.querySelector('a.navlink--child');
                  if (firstLink) {
                    setTimeout(() => firstLink.focus(), 100);
                  }
                }
              }
            }
          } else if (event.key === 'Escape') {
            const parentItem = this.closest('.menu__item[aria-haspopup="true"]');
            if (parentItem) {
              const isExpanded = parentItem.getAttribute('aria-expanded') === 'true';
              if (isExpanded) {
                parentItem.setAttribute('aria-expanded', false);
                const dropdownId = parentItem.getAttribute('aria-controls');
                const dropdown = document.getElementById(dropdownId);
                if (dropdown) {
                  dropdown.style.display = 'none';
                }
                this.focus();
              }
            }
          }
        });
      }
      
      menuItem.removeEventListener('keydown', menuItem._keydownHandler);
    });
    
    const dropdownLinks = document.querySelectorAll('.navlink--child');
    dropdownLinks.forEach(link => {
      if (!link.getAttribute('tabindex')) {
        link.setAttribute('tabindex', '0');
      }
      
      link.addEventListener('keydown', function(event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.click();
        } else if (event.key === 'Escape') {
          const parentDropdown = this.closest('.header__dropdown');
          if (parentDropdown) {
            const parentItem = document.querySelector(`[aria-controls="${parentDropdown.id}"]`);
            if (parentItem) {
              parentItem.setAttribute('aria-expanded', 'false');
              parentDropdown.style.display = 'none';
              const topLink = parentItem.querySelector('a.navlink--toplevel');
              if (topLink) {
                topLink.focus();
              }
            }
          }
        }
      });
    });
  }
  
  function initHeaderAccessibility() {
    const skipLink = document.querySelector('.in-page-link.visually-hidden.skip-link[data-skip-content]');
    if (skipLink) {
      skipLink.setAttribute('tabindex', '0');
      
      if (!skipLink.hasAttribute('data-safari-fixed')) {
        skipLink.setAttribute('data-safari-fixed', 'true');
        
        skipLink.addEventListener('keydown', function(event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            
            const mainContent = document.querySelector('#MainContent');
            if (mainContent) {
              mainContent.setAttribute('tabindex', '-1');
              mainContent.focus();
              
              setTimeout(() => {
                mainContent.removeAttribute('tabindex');
              }, 1000);
            } else {
              window.location.href = skipLink.getAttribute('href');
            }
          }
        });
        
        const body = document.body;
        if (body.firstChild) {
          body.insertBefore(skipLink, body.firstChild);
        }
      }
    }
    
    const announcementBarLinks = document.querySelectorAll('.announcement__text a');
    announcementBarLinks.forEach(link => {
      if (!link.getAttribute('tabindex')) {
        link.setAttribute('tabindex', '0');
      }
      
      link.addEventListener('keydown', function(event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.click();
        }
      });
    });
    
    const nonInteractiveAnnouncement = document.querySelectorAll('.announcement__text:not(:has(a))');
    nonInteractiveAnnouncement.forEach(element => {
      element.setAttribute('aria-hidden', 'true');
    });
    
    const logoLinks = document.querySelectorAll('.header__logo__link');
    logoLinks.forEach(link => {
      if (!link.getAttribute('tabindex')) {
        link.setAttribute('tabindex', '0');
      }
      
      link.addEventListener('keydown', function(event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.click();
        }
      });
    });
    
    const rightMenuItems = document.querySelectorAll('.header__desktop__bar__r .navlink');
    rightMenuItems.forEach(link => {
      if (!link.getAttribute('tabindex')) {
        link.setAttribute('tabindex', '0');
      }
      
      link.addEventListener('keydown', function(event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          
          if (this.classList.contains('navlink--cart')) {
            const cartToggle = this.querySelector('[data-cart-toggle]');
            if (cartToggle) {
              const cartEvent = new CustomEvent('click', {
                bubbles: true,
                cancelable: true
              });
              
              cartToggle.dispatchEvent(cartEvent);
              
              const cartDrawer = document.getElementById('cart-drawer');
              if (cartDrawer && !cartDrawer.classList.contains('is-open')) {
                cartDrawer.classList.add('is-open');
                
                const cartHead = cartDrawer.querySelector('.cart-drawer__head');
                if (cartHead) {
                  cartHead.classList.add('is-animated');
                }
                
                const closeButton = cartDrawer.querySelector('.cart-drawer__close');
                if (closeButton) {
                  setTimeout(() => {
                    closeButton.focus();
                  }, 100);
                }
              }
            } else {
              this.click();
            }
          } else {
            this.click();
          }
        }
      });
    });
    
    const mobileMenuButton = document.querySelector('.header__mobile__hamburger');
    if (mobileMenuButton) {
      mobileMenuButton.addEventListener('keydown', function(event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.click();
        }
      });
    }
    
    const allHeaderInteractiveElements = document.querySelectorAll(
      '.header__wrapper a[href], .header__wrapper button, .announcement__bar a[href]'
    );
    
    allHeaderInteractiveElements.forEach(element => {
      if (!element.getAttribute('tabindex') && !element.hasAttribute('disabled') && 
          element.style.display !== 'none' && element.style.visibility !== 'hidden') {
        element.setAttribute('tabindex', '0');
      }
    });
  }
  
  function initFooterNavigationKeyboardSupport() {
    const footerLinks = document.querySelectorAll('.footer_link_hoverable');
    
    footerLinks.forEach(link => {
      if (!link.getAttribute('tabindex')) {
        link.setAttribute('tabindex', '0');
      }
      
      link.addEventListener('keydown', function(event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.click();
        }
      });
    });
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    initMainNavigationKeyboardSupport();
    initFooterNavigationKeyboardSupport();
    initHeaderAccessibility();

    // Customer Data Requests page: consent preference delegated handler
    console.log('Customer Data Requests page script loaded');
    console.log('Setting up delegated click listener for consent preference link');
    document.body.addEventListener('click', function(e) {
      if (!window.location.pathname.includes('/pages/customer-data-requests')) return;
      const link = e.target.closest('a.pd-action-link');
      // only proceed for the specific "Change consent preference" link
      if (link && link.getAttribute('onclick') !== 'PandectesDsr.revokeConsent()') {
        console.log('Delegated: pd-action-link click ignored, not Change consent preference');
        return;
      }
      if (!link) return;
      console.log('Delegated: Change consent preference click detected');
      // inline PandectesDsr.revokeConsent() runs via the inline onclick
      setTimeout(function(){
        console.log('500ms elapsed after delegated click, opening preferences');
        if (window.Pandectes && Pandectes.fn && typeof Pandectes.fn.openPreferences === 'function') {
          console.log('Invoking Pandectes.fn.openPreferences() via delegated handler');
          Pandectes.fn.openPreferences();
          console.log('Pandectes.fn.openPreferences() called');
        }
      }, 500);
    });
  });
  
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(function() {
      initMainNavigationKeyboardSupport();
      initFooterNavigationKeyboardSupport();
      initHeaderAccessibility();
    }, 100);
  }
  /*---- End: Keyboard navigation support ----*/


  /*---- Update Color Name On Color Swatches Hover ---*/  
  if (window.location.pathname.indexOf('/products/') !== -1) {
    document.querySelectorAll('.swatch__button').forEach((ele) => {
      ele.addEventListener('mouseover', function(e) {
        if (e.target.dataset.swatch !== undefined && e.target.dataset.swatch !== '') {
          document.querySelector('.product__selectors legend.radio__legend [data-option-value]').innerHTML = e.target.dataset.swatch;
        }
      });
      
      ele.addEventListener('mouseout', function() {
        updateSelectedVariant(ele);
      });
  
      // Keyboard focus (since `tabindex="0"` is now on `.swatch__button`)
      ele.addEventListener('focus', function() {        
        if (ele.querySelector("label").dataset.swatch) {
          document.querySelector('.product__selectors legend.radio__legend [data-option-value]').innerHTML = ele.querySelector("label").dataset.swatch; 
        }        
      });


      // Keyboard blur (reset to selected variant)
      ele.addEventListener('blur', function() {
        updateSelectedVariant(ele);
      });

      // Enable selecting the variant using Enter/Space key
      ele.addEventListener('keydown', function(event) { 
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault(); // Prevents unintended scrolling when pressing Space
          ele.querySelector("input[type='radio']").click(); // Select the variant
        }
      });
       
    });
  }

  function updateSelectedVariant(ele) {
    const container = ele.closest('.selector-wrapper__swatches-container');
    const checkedRadioList = container ? container.querySelectorAll("input[type='radio']:checked") : [];
    [...checkedRadioList].forEach(v => { 
      if (v.dataset.index === "option1") {
        document.querySelector('.product__selectors legend.radio__legend [data-option-value]').innerHTML = v.defaultValue;
      }
    });
  }

  // Listen for changes on PDP main swatches only, not in recommendation/quick-add
  if (document.querySelector('#TemplateProduct.template-product-page')) {
    $(document).on("change", '#TemplateProduct .selector-wrapper input[type="radio"][data-index="option1"]', function () {
      const mobileBreakpoint = 750;
      const isMobile = $(window).width() <= mobileBreakpoint;
      if (isMobile) {
        $("html, body").animate(
          {
            scrollTop: 0,
          },
          200
        );
      }
    });
  }


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
   
  $(document).on("click", "[data-qatc-step]", function(e) {
    $(this).hide();    
    setColors(e);
    if($(this).hasClass('mobile-btn')) {
      $(this).parent().find('.quick-add-holder').addClass('open');
      $(this).parent().find('.quick-add-holder').find('[data-option-position="1"]').show();
    } else {
      $(this).parents('.quick-add-holder').find('[data-option-position="1"]').show();
    }    
  });
  
  $(document).on("click", "[data-go-to-next]", function() {
    disableOutOfStockItems(getOutOfStockItems($(this)),$(this));
    const currentStep = $(this).parents('.selector-wrapper').attr('data-option-position');
    if($(this).parent('.quick-atc-options-holder').find('.selected')) {
      $(this).parent('.quick-atc-options-holder').find('.selected').removeClass('selected')
    }
    $(this).addClass('selected');
    $(this).parents('.quick-add-holder').find(`[data-option-position="${parseInt(currentStep)}"]`).hide();    
    $(this).parents('.quick-add-holder').find(`[data-option-position="${parseInt(currentStep)+1}"]`).show();
  });
  
  $(document).on("click", "[data-back-button]", function() {
    const currentStep = $(this).parents('.selector-wrapper').attr('data-option-position');
    if($(this).parents('.selector-wrapper').find('.selected')) {
      $(this).parents('.selector-wrapper').find('.selected').removeClass('selected');
    }
    $(this).parents('.selector-wrapper').find('.no-stock').removeClass('no-stock');    
    $(this).parents('.quick-add-holder').find(`[data-option-position="${parseInt(currentStep)}"]`).hide();    
    $(this).parents('.quick-add-holder').find(`[data-option-position="${parseInt(currentStep)-1}"]`).show();
    if($(this).parents('.quick-add-holder').hasClass('open')) {
      $(this).parents('.quick-add-holder').removeClass('open');
    }
  });
  
  $(document).on("click", "[data-quick-add-button]", async function() {   
    const currentEle = $(this); 
    const currentStep = $(this).parents('.selector-wrapper').attr('data-option-position');
  
    if(currentEle.hasClass('no-stock')) {
      return;
    }   
  
    if($(this).parent('.quick-atc-options-holder').find('.selected')) {
      $(this).parent('.quick-atc-options-holder').find('.selected').removeClass('selected')
    }
    $(this).addClass('selected');
    
    const allSelectedOptions = $(this).parents('form').find('.selected');
    const productJson = JSON.parse($(this).parents('form').find('[data-product-json]').html());
  
    const loadingIcon = $(this).parents('.quick-add-holder').find('.qah-status');
    const isOption3Available = $(this).closest('.options-container').length > 0;
    let optionsSelected = false;
    if(isOption3Available) {
      const selectedOptions = $(this).closest('.options-container').find('.ss__swatch__option.selected');
      if(selectedOptions.length > 1) {
        optionsSelected = true;
        loadingIcon.addClass('is-loading');
      }
      $(this).parents('.quick-add-holder').addClass('options-on-hover');
    }else{
      loadingIcon.addClass('is-loading');
    }
  
    const variantId = getSelectedVariant(allSelectedOptions, productJson.variants);
  
    if(variantId !== null) {   
      const cartRes = await addToCart({id: variantId, quantity: 1});
      const res = await cartRes.json();
      
      if (!cartRes.ok) {
        loadingIcon.removeClass('is-loading');
        if(isOption3Available) {
          if(optionsSelected){
            loadingIcon.addClass('added-to-cart');
          }
        }else{
          loadingIcon.addClass('added-to-cart');
        }
        loadingIcon.find('.status-msg').text(res.description);
        setTimeout(() => {
          loadingIcon.removeClass('added-to-cart');
          resetQuickAdd(currentEle, currentStep);
        }, 2000);
  
        return;
      }      
      
      loadingIcon.find('.status-msg').html('ADDED TO BAG');
      loadingIcon.removeClass('is-loading');
      if(isOption3Available){
        if(optionsSelected){
          loadingIcon.addClass('added-to-cart');
        }
      }else{
        loadingIcon.addClass('added-to-cart');
      }
  
      window.cart.getCart();
  
      setTimeout(() => {
        loadingIcon.removeClass('added-to-cart');
        resetQuickAdd(currentEle, currentStep);
      }, 2000);
    }
  });
  
  function resetQuickAdd(currentEle, currentStep) {
    if(currentEle.parents('.quick-add-holder').hasClass('open')) {
      currentEle.parents('.quick-add-holder').removeClass('open');
    }
    currentEle.parents('.quick-add-holder').find(`[data-option-position="${parseInt(currentStep)}"]`).hide();    
    currentEle.parents('.quick-add-holder').find(`[data-option-position="0"]`).show();

    const parentContainer = $(currentEle).closest('.options-container');
    const selectedOptions = parentContainer.find('.ss__swatch__option.selected');

    if (selectedOptions.length > 1) {
      const selectedOptions = $(currentEle).closest('.options-container').find('.ss__swatch__option.selected');
      if (sessionStorage.getItem('selectedVariantOption3')) {
          selectedOptions.filter('.quick-atc-size-option').each(function() {
              $(this).removeClass('selected');
          });
      } else if(sessionStorage.getItem('selectedVariantOption2')){
        selectedOptions.filter('.quick-atc-option3-option').each(function() {
            $(this).removeClass('selected');
        });
      }
    }
  }
  
  function getSelectedVariant(allSelectedOptions, jsonData) {
    const variantData = jsonData.filter(vData => vData.option1 == allSelectedOptions[0].dataset.value && vData.option2 == allSelectedOptions[1].dataset.value);  
    const isOption3Exists = jsonData.some(vData => vData.option3 != null);
    let variantDataWithOption3 = null;
    if(isOption3Exists) {
      variantDataWithOption3 = jsonData.filter(vData => vData.option1 == allSelectedOptions[0].dataset.value && vData.option2 == allSelectedOptions[1].dataset.value && vData.option3 == allSelectedOptions[2]?.dataset.value); 
    }

    if(variantData && !isOption3Exists) {   
      return variantData[0].id;      
    } else if(variantDataWithOption3 && isOption3Exists) {
      return variantDataWithOption3[0]?.id;
    }
    return null;
  }
  
  
  async function addToCart(formData) {
    let data = formData;
      let headers = {
        'Content-Type': 'application/json',
      };
  
      if (typeof formData !== 'string') {
        data = new URLSearchParams(formData).toString();
        headers = {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded',
        };
      }
  
      const res = await fetch(theme.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: headers,
        body: data,
      })
  
      return res;
  }
  
  function getOutOfStockItems(currentEle) {
    const jsonData = JSON.parse(currentEle.parents('.quick-add-holder').find('[data-product-json]').html());
    if(jsonData) {
      const checkIfNoStock = jsonData.variants.filter(jData => jData.available === false);
      const outOfStockOptions = checkIfNoStock.map(jData => jData.options);
      
      if(outOfStockOptions) {
        return outOfStockOptions;
      }
    }
  
    return null;
  }
  
  function disableOutOfStockItems(outOfStockItems, currentEle) {
    if(outOfStockItems) {
      const selectedOption = currentEle.data().value;
      const currentOutOfStock = outOfStockItems.filter(osi => osi.includes(selectedOption)); 
      if(currentOutOfStock) {
        currentOutOfStock.forEach(element => {
          currentEle.parents('.quick-add-holder').find(`[data-value="${element[1]}"]`).addClass('no-stock')
        });      
      }         
    }   
  }
  
  function setColors(e) {
    const qatcSwatchers = $(e.target).parent().find('form .quick-atc-swatch-option[data-swatch]');
    const qatThemeGeneratedSwatchers = $(e.target).parents('.product-item').find('.product-information form label[data-swatch]'); 
    qatcSwatchers.each((index, ele) => {
      qatThemeGeneratedSwatchers.each((i, swatch) => {
        if(swatch.dataset.swatch === ele.dataset.swatch) {
          ele.style.cssText = swatch.style.cssText;
        }
      });
    })
  }


  /*---- Mobile Product Page Image Slider Custom Arrow ----*/
  if(document.querySelector('.template-product-page')) {
    if(document.querySelectorAll('.mobile-slider-nextprev-btn').length) {
      document.querySelectorAll('.mobile-slider-nextprev-btn').forEach((el) => {
        el.addEventListener('click', function(e) {
          if(e.target.classList.contains('previous')) {            
            e.target.parentElement.querySelector('.product__slides.product-single__photos').scrollLeft -= e.target.parentElement.clientWidth;
          }
          if(e.target.classList.contains('next')) {
            e.target.parentElement.querySelector('.product__slides.product-single__photos').scrollLeft += e.target.parentElement.clientWidth;
          }
        })
      })
    }
  }
})();

mobileQuickAtcBtnMove();

function mobileQuickAtcBtnMove() {
  if($("[data-quick-add-btn-mobile]").length) {
    $("[data-quick-add-btn-mobile]").each(function( index ) { 
      $(this).addClass('moved');     
      $(this).appendTo($(this).parents('.product-item').find('.product-information'));
    });
  }
}

document.addEventListener('theme:filter:reusltsUpdated', (e) => {
  mobileQuickAtcBtnMove();   
});

/* re init after Ajaxinate */
let collectionPageAjaxContent = document.getElementById('CollectionLoop'),
collectionOptions = {
  childList: true
}
if(collectionPageAjaxContent) {
  let collectionObserver = new MutationObserver(collectionCallBack);

  function collectionCallBack(mutations) {
  for (let mutation of mutations) {
    if (mutation.type === 'childList') {
      document.dispatchEvent(new CustomEvent("theme:filter:reusltsUpdated", {
        bubbles: false,
        detail: {
          filtersResultsUpdated: true
        }
      }));
    }
  }
  }

  collectionObserver.observe(collectionPageAjaxContent, collectionOptions);
}


document.querySelectorAll('.has-stl-item').forEach((ele => {
    ele.addEventListener('click', function(e) {
      const sectionId = e.target.dataset.sectionId;
      
      document.querySelectorAll(`.stl-item-content`).forEach((ele) => {
        ele.classList.remove('active')
      });
      
      if(e.target.dataset.id) {
        if(e.target.closest('.lb-stl-wrapper').querySelector(`.lb-stl-${e.target.dataset.id} .stl-item-content`).classList.contains('active')) {
          e.target.closest('.lb-stl-wrapper').querySelector(`.lb-stl-${e.target.dataset.id} .stl-item-content`).classList.remove('active');
        } else {
          e.target.closest('.lb-stl-wrapper').querySelector(`.lb-stl-${e.target.dataset.id} .stl-item-content`).classList.add('active');
        }  
      } else {
        if(e.target.closest('.lb-stl-wrapper').querySelector('.stl-item-content').classList.contains('active')) {
          e.target.closest('.lb-stl-wrapper').querySelector('.stl-item-content').classList.remove('active');
        } else {
          e.target.closest('.lb-stl-wrapper').querySelector('.stl-item-content').classList.add('active');
        }      
      } 

      if(sectionId && window.matchMedia("(min-width: 521px)").matches) {
        document.getElementById(sectionId).scrollIntoView(true);
      }

      const wrapper = e.currentTarget.closest('.lb-stl-wrapper');
      console.log('[DEBUG] Wrapper element:', wrapper);

      const isActive = wrapper.querySelector('.stl-item-content').classList.contains('active');
      console.log('[DEBUG] Is active:', isActive);

      if (isActive && window.innerWidth <= 520) {
        console.log('[DEBUG] Adding no-scroll class to body');
        document.body.classList.add('no-scroll');
      } else {
        console.log('[DEBUG] Removing no-scroll class from body');
        document.body.classList.remove('no-scroll');
      }
           
    })
}));


document.querySelectorAll('.lb-item-close-btn').forEach((ele => {
  ele.addEventListener('click', function(e) {
    if(e.target.parentElement.classList.contains('active')) {
      e.target.parentElement.classList.remove('active');
    }  
  })
}));


function processShippingBanner() {
  var globalEfreeShippingBanner = document.getElementById("FreeShippingBanner");
  var shippingBar = document.querySelector(".nili-globale-free-shipping-bar");

  if (globalEfreeShippingBanner && shippingBar) {
    shippingBar.textContent = globalEfreeShippingBanner.textContent;
    shippingBannerObserver.disconnect();
  }
}

var shippingBannerObserver = new MutationObserver(function(mutationsList) {
  for (var mutation of mutationsList) {
    if (mutation.type === "childList" && mutation.addedNodes.length) {
      var addedNode = mutation.addedNodes[0];
      if (addedNode.id === "FreeShippingBanner") {
        processShippingBanner();
      }
    }
  }
});

shippingBannerObserver.observe(document.body, { childList: true });

// function checkCookie(name) {
//   const value = `; ${document.cookie}`;
//   const parts = value.split(`; ${name}=`);
//   if (parts.length === 2) return parts.pop().split(';').shift();
//   return null;
// }

// if (checkCookie('locale_bar_accepted') || checkCookie('locale_bar_dismissed')) {
//   window._klOnsite = window._klOnsite || [];
//   window._klOnsite.push(['openForm', 'R9q9nz']);
// }

(function hideHamburgerOnStatusPage() {
  function checkUrlForStatus() {
      if (window.location.href.includes("status")) {
        const drawerElement = document.querySelector(".header__drawer");
        const hamburgerButton = document.querySelector(
          ".header__mobile__hamburger.drawer--visible"
        );

        drawerElement?.classList.contains("drawer--visible") &&
        hamburgerButton?.click();
      }
  }

  window.addEventListener("popstate", checkUrlForStatus);
  window.addEventListener("hashchange", checkUrlForStatus);
  checkUrlForStatus();
})();

// Begin: Product page media customizations
(function () {
  document.addEventListener("DOMContentLoaded", () => {
    if (!document.querySelector(".template-product-page")) {
      return;
    }

    const pdpSelectors = {
      thumbsContainer: ".product_thumbnails-container",
      productSwiper: ".swiper-container.product__swiper",
      productContent: ".product__content",
      productPage: ".product__page",
      productSwiperActiveSlide: ".product__swiper-slide.swiper-slide-active"
    };

    function disableZoomableImagesOnMobile() {
      if (window.innerWidth < 750) {
        const zoomableImages = document.querySelectorAll(".product__swiper-slide-image.zoomable-image");

        zoomableImages.forEach(image => {
          image.removeAttribute("data-image-src");
          image.style.backgroundImage = "none";
        });
      }
    }

    disableZoomableImagesOnMobile();

    let productSwiper;

    function initProductUIFeatures() {
      if (productSwiper) {
        productSwiper.destroy(true, true);
        productSwiper = null;
      }

      if (window.matchMedia("(min-width: 750px)").matches) {
        setupZoom();
        initializeSlidesOnDesktop();
      } else {
        initializeSlides();
      }

      setTimeout(() => {
        videoControls();
      }, 500);

      waitForSlides();
    }

    function initializeSlides() {
      const swiperWrapper = document.querySelector(".product__swiper .swiper-wrapper");
      swiperWrapper.innerHTML = "";

      document.querySelectorAll(".product__swiper-all-slides .product__slide").forEach(slide => {
        const displayStyle = slide.getAttribute("style");

        if (displayStyle && displayStyle.includes("display: block;")) {
          const newSlideElement = document.createElement("div");
          newSlideElement.classList.add("swiper-slide", "product__swiper-slide");
          newSlideElement.style.display = "block";
          newSlideElement.appendChild(slide.cloneNode(true));
          swiperWrapper.appendChild(newSlideElement);
        } else if (slide && !displayStyle) {
          const newSlideElement = document.createElement("div");
          newSlideElement.classList.add("swiper-slide", "product__swiper-slide");
          newSlideElement.style.display = "block";
          newSlideElement.appendChild(slide.cloneNode(true));
          swiperWrapper.appendChild(newSlideElement);
        }
      });

      initializeSwiper();
    }

    function initializeSlidesOnDesktop() {
      const imagesContainer = document.querySelector(".product__images");
      imagesContainer.classList.remove("transition-completed");

      setTimeout(() => {
        const swiperWrapper = document.querySelector(".product__swiper .swiper-wrapper");
        swiperWrapper.innerHTML = "";

        document.querySelectorAll(".product__swiper-all-slides .product__slide").forEach(slide => {
          const displayStyle = slide.getAttribute("style");

          if (displayStyle && displayStyle.includes("display: block;")) {
            const newSlideElement = document.createElement("div");
            newSlideElement.classList.add("swiper-slide", "product__swiper-slide");
            if (slide.getAttribute("data-type") === "video") {
              newSlideElement.classList.add("product__swiper-slide-video");
              newSlideElement.style.display = "flex";
            } else {
              newSlideElement.style.display = "block";
            }
            newSlideElement.appendChild(slide.cloneNode(true));
            swiperWrapper.appendChild(newSlideElement);
          } else if (slide && !displayStyle) {
            const newSlideElement = document.createElement("div");
            newSlideElement.classList.add("swiper-slide", "product__swiper-slide");
            if (slide.getAttribute("data-type") === "video") {
              newSlideElement.classList.add("product__swiper-slide-video");
              newSlideElement.style.display = "flex";
            } else {
              newSlideElement.style.display = "block";
            }
            newSlideElement.appendChild(slide.cloneNode(true));
            swiperWrapper.appendChild(newSlideElement);
          }
        });

        initializeSwiper();
      }, 300);
    }

    let wasSingleMedia = false;
    setTimeout(() => {
      initProductUIFeatures();
      const initialProductImage = document.querySelector(".product__images");
      wasSingleMedia = initialProductImage && initialProductImage.classList.contains("product__images--single-media");
      // Apply initial zoom-related adjustments
      applyPdpZoomImageHeightFix();
    }, 0);

    // === PDP Zoom Accessibility helpers ===
    function isDesktopNonMobileUA() {
      const ua = navigator.userAgent.toLowerCase();
      return !(/mobile|android|iphone|ipad|ipod|tablet|kindle|silk/.test(ua));
    }

    function isExtremeZoom300() {
      // Prefer visualViewport when available
      if (window.visualViewport && typeof window.visualViewport.scale === 'number') {
        const extreme = window.visualViewport.scale >= 3;
        console.log(`[PDP Zoom ADA] VV scale=${window.visualViewport.scale.toFixed(2)} => extreme=${extreme}`);
        return extreme;
      }
      // Fallback heuristic
      const cssVw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      const dpr = window.devicePixelRatio || 1;
      const extreme = (dpr >= 3) || (cssVw <= 480);
      console.log(`[PDP Zoom ADA] fallback dpr=${dpr}, cssVw=${cssVw} => extreme=${extreme}`);
      return extreme;
    }

    function applyPdpZoomImageHeightFix() {
      const imagesEl = document.querySelector('.product__images');
      if (!imagesEl) return;

      const isDesktopWidth = window.matchMedia && window.matchMedia('(min-width: 750px)').matches;
      const isDesktopUA = isDesktopNonMobileUA();
      const extreme = isExtremeZoom300();

      // Condition: real extreme zoom on desktop OR (viewport <= 749px but UA is desktop)
      const viewportLooksMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
      const shouldUnset = (isDesktopWidth && extreme) || (!isDesktopWidth && viewportLooksMobile && isDesktopUA);

      if (shouldUnset) {
        imagesEl.style.maxHeight = 'unset';
        console.log('[PDP Zoom ADA] unset max-height on .product__images');
      } else {
        imagesEl.style.removeProperty('max-height');
        console.log('[PDP Zoom ADA] removed inline max-height override on .product__images');
      }
    }


    function handleSingleMediaProducts() {
      const productThumbsContainer = document.querySelector(".product_thumbnails-container");
      const productImageContainer = document.querySelector(".product__images");

      if (!productThumbsContainer || !productImageContainer) return;

      const thumbsClsObserver = new MutationObserver(() => {
        const productThumbs = productThumbsContainer.classList;

        const countClass = Array.from(productThumbs).find(className => className.includes("product_thumbnails-count-"));

        if (countClass) {
          const count = countClass.split("-").pop();
          if (count == 1) {
            productImageContainer.classList.add("product__images--single-media");
            productImageContainer.style.removeProperty("grid-template-columns");
            wasSingleMedia = true; 
          } else {
            productImageContainer.classList.remove("product__images--single-media");
          }
        }

        thumbsClsObserver.disconnect();
      });

      thumbsClsObserver.observe(productThumbsContainer, { attributes: true });

      const productThumbs = productThumbsContainer.classList;

      const countClass = Array.from(productThumbs).find(className => className.includes("product_thumbnails-count-"));

      if (countClass) {
        const count = countClass.split("-").pop();
        if (count == 1) {
          productImageContainer.classList.add("product__images--single-media");
          productImageContainer.style.removeProperty("grid-template-columns");
          wasSingleMedia = true;
        } else {
          productImageContainer.classList.remove("product__images--single-media");
        }
      }
    }

    function handleSwatchClick() {
      const prevSingleMedia = wasSingleMedia;
      setTimeout(() => {
        initProductUIFeatures();
        handleSingleMediaProducts();
        
        var formOuter = document.querySelector('.product__form__outer');
        var isGiftCard = formOuter && formOuter.classList.contains('gift-card-product-form-container');

        if (prevSingleMedia && window.innerWidth > 750 && !isGiftCard) {
          setTimeout(calculateContentMargin, 500)
        }
        
        const updatedImages = document.querySelector(".product__images");
        wasSingleMedia = updatedImages && updatedImages.classList.contains("product__images--single-media");
      }, 0);
    }

    document.querySelectorAll('input[type="radio"][data-index="option1"]').forEach(input => {
      input.addEventListener("click", handleSwatchClick);
    });

    let marginCalculationCounter = 0;

    function runCalculateMarginOnce() {
      if (window.innerWidth < 750) return;

      marginCalculationCounter++;
      if (marginCalculationCounter > 1) return;

      const activeSlideImages = document.querySelectorAll(".swiper-slide.swiper-slide-active .product__swiper-slide-image img");
      let imagesLoaded = 0;
      const totalImages = activeSlideImages.length;

      if (totalImages === 0) {
        calculateContentMargin();
        return;
      }

      function imageLoaded() {
        imagesLoaded++;
        if (imagesLoaded === totalImages) {
          calculateContentMargin();
        }
      }

      activeSlideImages.forEach(function (img) {
        if (img.complete) {
          imageLoaded();
        } else {
          img.addEventListener("load", imageLoaded);
        }
      });
    }

    function preloadZoomableImage(element) {
      if (window.innerWidth < 750 || !element) return;
      let imageUrl = element.getAttribute("data-image-src");
      if (imageUrl) {
        const preloadImg = new Image();
        preloadImg.src = imageUrl;
      }
    }


    let isSwiperScrolling = false;

    function initializeSwiper() {
      productSwiper = new Swiper(".product__swiper", {
        slidesPerView: 1,
        zoom: false,
        loop: true,
        speed: 800,
        effect: "slide",
        direction: "horizontal",
        spaceBetween: 0,
        centeredSlides: true,
        observer: true,
        observeParents: true,
        mousewheel: true,
        shortSwipes: true,
        touchMoveStopPropagation: true,
        touchAngle: 50,
        autoHeight: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          750: {
            direction: "vertical",
            grabCursor: false,
            spaceBetween: 0,
            slidesPerView: 1,
            slidesPerGroup: 1,
            speed: 800,
            observer: true,
            observeParents: true,
            autoHeight: false,
            zoom: false,
            centeredSlides: false,
          },
        },
        on: {
          slideChange: function () {
            document.querySelectorAll(".product__swiper .product__slide").forEach(slide => {
              slide.classList.remove("pdp-thumb-fade-in", "pdp-thumb-fade-out");
            });
            setTimeout(() => {
              const activeSlide = document.querySelector(".product__swiper .swiper-slide-active .product__slide");
              const activeSlideMediaID = activeSlide?.getAttribute("data-media-id");

              const productThumbs = document.querySelectorAll(".product_thumbnails-container .product__slide");
              const currentProductThumbs = Array.from(productThumbs).filter(slide => getComputedStyle(slide).display === "block");

              productThumbs.forEach(thumb => thumb.classList.remove("selected-thumbnail"));

              currentProductThumbs.forEach((thumb, index) => {
                const thumbMediaID = thumb.getAttribute("data-media-id");
                if (activeSlideMediaID === thumbMediaID) {
                  thumb.classList.add("selected-thumbnail");
                  scrollSelectedThumbnailIntoView();
                }
              });
              const currentSlideElement = document.querySelector(".product__swiper_custom-pagination-current");

              if (!isNaN(this.activeIndex) && currentSlideElement) {
                currentSlideElement.innerHTML = this.realIndex + 1;
              } else {
                currentSlideElement.innerHTML = "1";
              }

              //const zoomableImage = activeSlide.querySelector(".zoomable-image");
              //preloadZoomableImage(zoomableImage);

              initImageMobileZoom();
            }, 100);

            setTimeout(() => {
              const selectedVideoId = document.querySelector(".product_thumbnails-container .product__slide.selected-thumbnail")?.getAttribute("data-video-id");
              const activeVideo = document.querySelector(`.product__swiper .swiper-slide .product__slide[data-video-id='${selectedVideoId}'] video`);

              document.querySelectorAll(".product__swiper .product__slide[data-type='video'] video").forEach(video => {
                if (video !== activeVideo && !video.hasAttribute("data-video-paused")) {
                  video.pause();
                  const controlButton = video.parentElement.querySelector("button.control-button");
                  if (controlButton) {
                    controlButton.style.backgroundImage = "var(--ICON-PAUSE-PDP)";
                  }
                }
              });

              if (activeVideo && !activeVideo.hasAttribute("data-video-paused")) {
                activeVideo.muted = true;
                activeVideo.play();
              }
            }, 500);
          },
          init: function () {
            setTimeout(() => {
              const activeSlide = document.querySelector(".product__swiper .swiper-slide-active .product__slide");
              const activeSlideMediaID = activeSlide?.getAttribute("data-media-id");

              const productThumbs = document.querySelectorAll(".product_thumbnails-container .product__slide");
              const currentProductThumbs = Array.from(productThumbs).filter(slide => getComputedStyle(slide).display === "block");

              productThumbs.forEach(thumb => thumb.classList.remove("selected-thumbnail"));

              currentProductThumbs.forEach((thumb, index) => {
                const thumbMediaID = thumb.getAttribute("data-media-id");
                if (activeSlideMediaID === thumbMediaID) {
                  thumb.classList.add("selected-thumbnail");
                  scrollSelectedThumbnailIntoView();
                }
              });

              const selectedVideoId = document.querySelector(".product_thumbnails-container .product__slide.selected-thumbnail")?.getAttribute("data-video-id");
              const activeVideo = document.querySelector(`.product__swiper .swiper-slide .product__slide[data-video-id='${selectedVideoId}'] video`);

              document.querySelectorAll(".product__swiper .product__slide[data-type='video'] video").forEach(video => {
                if (video !== activeVideo && !video.hasAttribute("data-video-paused")) {
                  video.pause();
                }
              });

              if (activeVideo && !activeVideo.hasAttribute("data-video-paused")) {
                activeVideo.muted = true;
                activeVideo.play();
              }
              if (window.matchMedia("(min-width: 750px) and (orientation: landscape)").matches) {
                applyContainAndScrollableIfNeeded();
                adjustGridTemplateColumns();
              }
              if (window.innerWidth < 750) {
                // fixedATCSection();
                const totalSlides = this.slides.length;
                if (totalSlides === 1) {
                  initImageMobileZoom();
                }
              }

              const zoomableImage = activeSlide.querySelector(".zoomable-image");
              preloadZoomableImage(zoomableImage);

              runCalculateMarginOnce();
            }, 100);
          },
          touchStart: function (event) {
            if (event.touches && event.touches.length > 1) {
              this.allowTouchMove = false;
            }
            isSwiperScrolling = true;
          },
          touchEnd: function () {
            this.allowTouchMove = true;
          },
          slideChangeTransitionEnd: () => {
            isSwiperScrolling = false;
          },
        },
      });
    }

    function thumbnailActions() {
      const productThumbs = Array.from(document.querySelectorAll(".product_thumbnails-container .product__slide")).filter(slide => getComputedStyle(slide).display === "block");
      const productImageContainer = document.querySelector(".product__images");

      let currentIndex = 0;

      const productThumbnailContainer = document.querySelector(".product_thumbnails-container");

      productThumbnailContainer.classList.forEach(className => {
        if (className.startsWith("product_thumbnails-count-")) {
          productThumbnailContainer.classList.remove(className);
        }
      });
      const hiddenThumbs = Array.from(document.querySelectorAll(".product_thumbnails-container .product__slide")).filter(slide => getComputedStyle(slide).display === "none");

      const productPageContainer = productThumbnailContainer.closest(".product__page");
      productPageContainer.classList.remove("contain-thumbs");

      productThumbnailContainer.classList.add(`product_thumbnails-count-${productThumbs.length}`);
      if (productThumbs.length === 1) {
        productImageContainer.classList.add("product__images--single-media");
      } else if (productThumbs.length === 6 || productThumbs.length === 3) {
        productPageContainer.classList.add("contain-thumbs");
      } else {
        productImageContainer.classList.remove("product__images--single-media");
      }

      if (productThumbnailContainer.classList.contains("multiple-colors-available") || hiddenThumbs.length > 0) {
        const visibleThumbs = Array.from(productThumbnailContainer.querySelectorAll('.product__slide[style*="display: block"]'));

        visibleThumbs.forEach((slide, index) => {
          slide.classList.remove("grid-column-span-1", "grid-column-span-2");
          if (productThumbs.length <= 3) {
            slide.classList.add("grid-column-span-2");
          } else if (productThumbs.length === 4) {
            slide.classList.add(index === 0 || index === 3 ? "grid-column-span-2" : "grid-column-span-1");
          } else if (productThumbs.length === 5) {
            slide.classList.add(index === 2 ? "grid-column-span-2" : "grid-column-span-1");
          } else if (productThumbs.length === 6) {
            slide.classList.add(index === 2 || index === 5 ? "grid-column-span-2" : "grid-column-span-1");
          } else if (productThumbs.length >= 8) {
            if (index === 2 || index === 5 || (index === 8 && productThumbs.length > 8) || (index === 11 && productThumbs.length > 11)) {
              slide.classList.add("grid-column-span-2");
            } else {
              slide.classList.add("grid-column-span-1");
            }
          } else {
            slide.classList.add(index === 2 || index === 5 ? "grid-column-span-2" : "grid-column-span-1");
          }
        });
      }

      if (window.innerWidth >= 750) {
        productThumbnailContainer.style.display = "grid";
      }

      if (productThumbs.length > 0) {
        const customTotalSlidesContainer = document.querySelector(".product__swiper_custom-pagination-container");

        setTimeout(() => {
          const totalSlidesElement = document.querySelector(".product__swiper_custom-pagination-total");
          customTotalSlidesContainer.style.visibility = "visible";

          if (totalSlidesElement) {
            totalSlidesElement.innerHTML = productThumbs.length;
          }
        }, 100);

        const activeSlidePositions = Array.from(productThumbs).map(thumb => thumb.getAttribute("data-slide-position"));
        document.querySelectorAll(".product__swiper-slide").forEach(slide => {
          const slidePosition = slide.querySelector(".product__slide")?.getAttribute("data-slide-position");

          if (!activeSlidePositions.includes(slidePosition)) {
            slide.style.display = "none";
          } else {
            slide.style.display = "block";
          }
        });

        productThumbs.forEach((thumbSlide, index) => {
          let thumbnailElement = thumbSlide.querySelector(".product__thumbnail-image");
        
          if (!thumbnailElement) {
            const lazyImageContainer = thumbSlide.querySelector(".product__swiper-slide-image");
            const videoElement = lazyImageContainer ? lazyImageContainer.querySelector("video") : null;
        
            if (videoElement) {
              thumbSlide.appendChild(videoElement);
              lazyImageContainer.style.backgroundImage = "none";
              thumbnailElement = videoElement;
            }
          }
        
          if (thumbnailElement) {
            thumbnailElement.addEventListener("click", () => {
              if (isSwiperScrolling) {
                console.log("[⚠️] Ignored thumbnail click: Swiper is still scrolling");
                return;
              }
              
              const selectedMediaId = thumbSlide.getAttribute("data-media-id");

              // Update thumbnail UI
              productThumbs.forEach(t => t.classList.remove("selected-thumbnail"));
              thumbSlide.classList.add("selected-thumbnail");
              scrollSelectedThumbnailIntoView();

              // Find matching slide index
              const allSwiperSlides = document.querySelectorAll(".product__swiper .swiper-slide");
              let matchedIndex = -1;

              allSwiperSlides.forEach((swiperSlide, i) => {
                const mediaId = swiperSlide.querySelector(".product__slide")?.getAttribute("data-media-id");
                if (mediaId === selectedMediaId && matchedIndex === -1) {
                  matchedIndex = i;
                }
              });

              if (matchedIndex !== -1 && window.innerWidth >= 750) {

                const currentActiveSlide = document.querySelector(".product__swiper .swiper-slide-active .product__slide");
                const currentMediaId = currentActiveSlide?.getAttribute("data-media-id");

                if (currentMediaId === selectedMediaId) {
                  console.log("[⛔️] Clicked same image, skipping fade/slide");
                  return;
                }

                const allSlides = document.querySelectorAll(".product__swiper .swiper-slide");
                const targetSlide = allSlides[matchedIndex];
                const targetSlideContent = targetSlide?.querySelector(".product__slide");
              
                if (targetSlideContent) {
                  // 1️⃣ Set opacity to 0 before navigating
                  targetSlideContent.classList.remove("pdp-thumb-fade-in", "pdp-thumb-fade-out");
                  targetSlideContent.style.opacity = "0";
                }
              
                // 2️⃣ Instantly switch slide
                productSwiper.slideTo(matchedIndex, 0);
              
                // 3️⃣ Wait for Swiper to update DOM
                setTimeout(() => {
                  const newActiveSlide = document.querySelector(".product__swiper .swiper-slide-active .product__slide");
                  if (newActiveSlide) {
                    // 🔁 Use next tick to trigger fade in
                    requestAnimationFrame(() => {
                      newActiveSlide.classList.add("pdp-thumb-fade-in");
                      newActiveSlide.style.opacity = ""; // allow CSS to animate
                    });
              
                    setTimeout(() => {
                      newActiveSlide.classList.remove("pdp-thumb-fade-in");
                    }, 600); // match fade duration
                  }
                }, 20);
              }
              
            });
          }
        });
      }
    }

    function scrollSelectedThumbnailIntoView() {
      const thumbsContainer = document.querySelector(".product_thumbnails-container.scrollable-thumbnails");
      if (!thumbsContainer) return;
    
      const selectedThumb = thumbsContainer.querySelector(".product__slide.selected-thumbnail");
      if (!selectedThumb) return;
    
      // Smoothly scroll so the selected thumbnail is visible
      selectedThumb.scrollIntoView({
        behavior: "smooth",
        block:    "nearest"
      });
    }
    

    function waitForSlides() {
      const productThumbs = document.querySelectorAll(".product_thumbnails-container .product__slide[style*='display: block']");

      if (productThumbs.length > 0) {
        thumbnailActions();
        document.querySelector(".product_thumbnails-container").classList.remove("hidden");
        observer.disconnect();
      } else {
        // Get all slides that do not have 'display: none' style
        const visibleSlides = Array.from(document.querySelectorAll(".product_thumbnails-container .product__slide")).filter(slide => window.getComputedStyle(slide).display !== "none");

        if (visibleSlides.length > 0) {
          thumbnailActions();
          document.querySelector(".product_thumbnails-container").classList.remove("hidden");
          observer.disconnect();
        }
      }
    }

    document.querySelector(".product_thumbnails-container").classList.add("hidden");

    const observer = new MutationObserver(waitForSlides);
    observer.observe(document.querySelector(".product_thumbnails-container"), {
      childList: true,
      subtree: true,
    });

    function videoControls() {
      const playPauseBtns = document.querySelectorAll(".product__swiper .product__media-video-holder .video-controls .control-button");

      playPauseBtns.forEach(playPauseBtn => {
        playPauseBtn.addEventListener("click", () => {
          handleVideoPlayPause(playPauseBtn);
        });
      });

      const videos = document.querySelectorAll(".product__swiper .product__slide video");

      videos.forEach(video => {
        video.addEventListener("click", () => {
          const videoHolder = video.closest(".product__media-video-holder");
          const correspondingBtn = videoHolder?.querySelector(".video-controls .control-button");

          if (correspondingBtn) {
            handleVideoPlayPause(correspondingBtn);
          }
        });
      });

      function handleVideoPlayPause(button) {
        const videoHolder = button.closest(".product__media-video-holder");
        const video = videoHolder?.querySelector("video");

        if (video) {
          if (video.paused) {
            video.play();
            button.style.backgroundImage = "var(--ICON-PAUSE-PDP)";
            video.removeAttribute("data-video-paused");
          } else {
            video.pause();
            button.style.backgroundImage = "var(--ICON-PLAY-PDP)";
            video.setAttribute("data-video-paused", "true");
          }

          isSwiperScrolling = false;

        }
      }
    }


    // Start : Desktop PDP Image Zoom 

    function toggleImageZoom(event) {
      const container = event.currentTarget;
      let zoomLevel = container.getAttribute("data-zoom-level") || "0";
      zoomLevel = parseInt(zoomLevel);
      
      //console.log("Current zoom level:", zoomLevel);
      
      if (zoomLevel === 0) {
      enableZoom(container, 150, "var(--ICON-ZOOM-IN), zoom-in");
      container.setAttribute("data-zoom-level", "1");
      } else if (zoomLevel === 1) {
      enableZoom(container, 300, "var(--ICON-ZOOM-OUT), zoom-out");
      container.setAttribute("data-zoom-level", "2");
      } else {
      disableZoom(container);
      //console.log("Zoom disabled");
      }
    }

    function enableZoom(container, zoomPercent, cursorType) {
      const zoomImage = container.getAttribute("data-image-src");
      container.style.backgroundImage = `url(${zoomImage})`;
      container.style.backgroundSize = `${zoomPercent}%`;
      container.classList.add("zoom-enabled");
      container.querySelector("img").style.opacity = 0;
      container.style.cursor = cursorType;
    }

    function disableZoom(container) {
      container.style.backgroundImage = "";
      container.style.backgroundSize = "";
      container.classList.remove("zoom-enabled");
      container.querySelector("img").style.opacity = 1;
      container.setAttribute("data-zoom-level", "0");
      container.style.cursor = "var(--ICON-ZOOM-IN-CIRCLE), zoom-in";

      isSwiperScrolling = false;

    }

    function moveBackground(event) {
      const container = event.currentTarget;
      if (!container.classList.contains("zoom-enabled")) return;
      
      const rect = container.getBoundingClientRect();
      const offsetX = ((event.clientX - rect.left) / rect.width) * 100;
      const offsetY = ((event.clientY - rect.top) / rect.height) * 100;
      
      container.style.backgroundPosition = `${offsetX}% ${offsetY}%`;
    }

    function setupZoom() {
      setTimeout(() => {
        const zoomElements = document.querySelectorAll(".product__swiper-wrapper .zoomable-image");
        zoomElements.forEach(element => {
          element.addEventListener("click", toggleImageZoom);
          element.addEventListener("mouseleave", () => disableZoom(element));
          element.addEventListener("mousemove", moveBackground);
        });
      }, 1000);
    }

    // End : Desktop PDP Image Zoom 


    // function scrollBackground(event) {
    //   const container = event.currentTarget;
    //   event.preventDefault();

    //   if (event.target.classList.contains("zoomable-image")) {
    //     event.stopPropagation();
    //   }

    //   const rect = container.getBoundingClientRect();
    //   const scrollSpeed = 0.5;
    //   const currentYPos = parseFloat(container.style.backgroundPosition.split(" ")[1]) || 50;

    //   let newYPos = currentYPos + ((event.deltaY * scrollSpeed) / rect.height) * 100;
    //   newYPos = Math.min(100, Math.max(0, newYPos));

    //   container.style.backgroundPosition = `center ${newYPos}%`;

    //   if (newYPos <= 0 || newYPos >= 100) {
    //     disableZoom(container);
    //     document.querySelector(".product__swiper").removeEventListener("wheel", stopWheelPropagation);
    //   } else {
    //     document.querySelector(".product__swiper").addEventListener("wheel", stopWheelPropagation);
    //   }
    // }

    // function stopWheelPropagation(event) {
    //   event.stopPropagation();
    // }

    const productThumbnailContainer = document.querySelector(".product_thumbnails-container");

    function waitForElements(...selectors) {
      return new Promise(resolve => {
        const getElements = () => selectors.map(selector => document.querySelector(selector));
        let elements = getElements();

        if (elements.every(el => el)) {
          resolve(elements);
          return;
        }

        const observer = new MutationObserver(() => {
          elements = getElements();
          if (elements.every(el => el)) {
            observer.disconnect();
            resolve(elements);
          }
        });

        observer.observe(document.body, { childList: true, subtree: true });
      });
    }

    function applyContainAndScrollableIfNeeded() {
      const thumbsContainer = document.querySelector(".product_thumbnails-container");
      const productPageContainer = document.querySelector(".product__page");
      if (!thumbsContainer || !productPageContainer) return;
  
      // Count only the visible thumbnails
      const visibleThumbs = Array.from(thumbsContainer.querySelectorAll(".product__slide"))
          .filter(slide => getComputedStyle(slide).display !== "none");
  
      //console.log("Number of visible thumbnails:", visibleThumbs.length);
  
      if (visibleThumbs.length > 6) {
          thumbsContainer.classList.add("scrollable-thumbnails");
          productPageContainer.classList.add("contain-thumbs");
          //console.log("Added 'scrollable-thumbnails'");
      } else if (visibleThumbs.length == 6 || visibleThumbs.length == 3) {
          //productPageContainer.classList.remove("contain-thumbs");
          thumbsContainer.classList.remove("scrollable-thumbnails");
      } else {
          thumbsContainer.classList.remove("scrollable-thumbnails");
          productPageContainer.classList.remove("contain-thumbs");

      }
    }

    applyContainAndScrollableIfNeeded();

    function initScrollCarat() {

      // The element that actually scrolls
      const scrollContainer = document.querySelector(".product_thumbnails-container");
      if (!scrollContainer) return;

      // Check product thumbnail count from class
      const match = scrollContainer.className.match(/product_thumbnails-count-(\d+)/);
      const thumbnailCount = match ? parseInt(match[1], 10) : 0;

      //console.log("Thumbnail count detected:", thumbnailCount);

      // Check if scrolling is actually needed
      const isScrollable = scrollContainer.scrollHeight > scrollContainer.clientHeight;

      // If images are ≤ 6 OR there's no scrolling needed, remove the caret and exit
      if (thumbnailCount <= 6 || !isScrollable) {
        //console.log("Not enough images OR no scrolling needed, removing carat.");
        const existingArrow = document.querySelector(".scroll-caret");
        if (existingArrow) existingArrow.remove();
        return;
      }

      // The parent wrapper (position: relative) for our arrow
      const wrapper = document.querySelector(".product_thumbnails-wrapper");
      if (!wrapper) return;
    
      // Create/find the arrow
      let caratIcon = wrapper.querySelector(".scroll-caret");
      if (!caratIcon) {
        caratIcon = document.createElement("img");
        caratIcon.src = window.themeAssets?.downCaret || "";
        caratIcon.alt = "Scroll caret";
        caratIcon.classList.add("scroll-caret");
        wrapper.appendChild(caratIcon);
      }
    
      // Helper to show arrow at bottom-right (down arrow)
      function showDownArrow() {
        caratIcon.style.top = "auto";
        caratIcon.style.bottom = "15px";
        caratIcon.style.transform = "rotate(0deg)";
        caratIcon.style.opacity = ".5";
        caratIcon.style.pointerEvents = "auto";
      }
    
      // Helper to show arrow at top-right (up arrow)
      function showUpArrow() {
        caratIcon.style.bottom = "auto";
        caratIcon.style.top = "15px";
        caratIcon.style.transform = "rotate(180deg)";
        caratIcon.style.opacity = ".5";
        caratIcon.style.pointerEvents = "auto";
      }
    
      // Hide arrow entirely
      function hideArrow() {
        caratIcon.style.opacity = "0";
        caratIcon.style.pointerEvents = "none";
      }
    
      function updateCaratPosition() {
        const scrollTop = scrollContainer.scrollTop;
        const clientHeight = scrollContainer.clientHeight;
        const scrollHeight = scrollContainer.scrollHeight;
    
        if (scrollTop <= 0) {
          showDownArrow();
        }
        else if (scrollTop + clientHeight >= scrollHeight - 5) {
          showUpArrow();
        }
        else {
          hideArrow();
        }
      }
    
      // On click, scroll to top or bottom
      caratIcon.addEventListener("click", () => {
        if (caratIcon.style.transform === "rotate(180deg)") {
          // up arrow → scroll to top
          scrollContainer.scrollTo({ top: 0, behavior: "smooth" });
        } else {
          // down arrow → scroll to bottom
          scrollContainer.scrollTo({ top: scrollContainer.scrollHeight, behavior: "smooth" });
        }
      });
    
      // Listen for scroll changes on the real scroll container
      scrollContainer.addEventListener("scroll", updateCaratPosition);
    
      // Initialize
      updateCaratPosition();
    }
    
    
    window.addEventListener('load', () => {
      initScrollCarat();
    });
    
    
    if (window.innerWidth >= 949) {
      adjustGridTemplateColumns();
    }

    
    function watchForThumbnailChanges() {
      const container = document.querySelector(".product_thumbnails-container");
      if (!container) return;
    
      const observer = new MutationObserver((mutations, obs) => {
        //console.log("DOM mutation detected! Waiting for updates...");
    
        // Delay execution to allow all updates to settle
        setTimeout(() => {
          //console.log("Running `initScrollCarat()` after delay...");
          initScrollCarat();
          obs.disconnect(); // Stop observing after update
        }, 50); // Adjust delay if necessary
      });
    
      observer.observe(container, { childList: true, attributes: true, subtree: true });
    }
    
    document.querySelectorAll(".swatch__button").forEach(button => {
      button.addEventListener("click", () => {
        //console.log("==== Swatch clicked! Re-running logic ====");
    
        applyContainAndScrollableIfNeeded(); // Re-check scrollability
        adjustGridTemplateColumns(); // Adjust layout
    
        watchForThumbnailChanges(); // Observe updates + add delay
      });
    });
    
    
    
    
    

    



    function measureForSixSlidesOnly(thumbsContainer) {
      //console.log("Starting measureForSixSlidesOnly function");
  
      // First, get ONLY the visible slides (filter first)
      const visibleSlides = Array.from(thumbsContainer.querySelectorAll(".product__slide"))
          .filter(slide => getComputedStyle(slide).display !== "none");
  
      //console.log("Visible slides found:", visibleSlides.length);
  
      // Now take only the first 6 visible ones
      const firstSixSlides = visibleSlides.slice(0, 6);
  
      //console.log("First 6 visible slides:", firstSixSlides);
  
      if (firstSixSlides.length < 6) {
          console.warn("Not enough thumbnails to measure correctly.");
          return thumbsContainer.offsetWidth / thumbsContainer.offsetHeight;
      }
  
      // Calculate the total bounding box covering only the first six slides
      const firstSlideTop = firstSixSlides[0].getBoundingClientRect().top;
      const lastSlideBottom = firstSixSlides[firstSixSlides.length - 1].getBoundingClientRect().bottom;
      const totalHeight = lastSlideBottom - firstSlideTop;
  
      //console.log("Corrected height measurement:", totalHeight);
  
      // Get the width of the entire container
      const containerWidth = thumbsContainer.getBoundingClientRect().width;
  
      // Calculate the corrected aspect ratio
      const aspectRatio = containerWidth / totalHeight;
      //console.log("Corrected aspect ratio:", aspectRatio);
  
      return aspectRatio;
  }
  
  
    let resizeTriggered = false;
    async function adjustGridTemplateColumns() {
      const [imagesContainer, thumbsContainer, productSwiper, productPageContainer] = await waitForElements(".product__images", ".product_thumbnails-container", ".swiper-container.product__swiper", ".product__page");
      const mainContent = document.querySelector('#MainContent');
      const computedStyle = window.getComputedStyle(mainContent);
      const paddingTopStr = computedStyle.getPropertyValue('padding-top');
      const headerPadding = parseFloat(paddingTopStr);
      const viewPortCustomHeight = window.innerHeight - headerPadding;

      const productSlideImages = document.querySelectorAll(".swiper-slide.product__swiper-slide .product__swiper-slide-image.zoomable-image img");
      const productSlideVideos = document.querySelectorAll(".swiper-slide.product__swiper-slide video");

      imagesContainer.classList.remove("transition-completed");

      if (isDesktopDevice()) {
        const countMatch = thumbsContainer.className.match(/product_thumbnails-count-(\d+)/);
        const count = countMatch ? parseInt(countMatch[1], 10) : null;

        if (count !== null && count < 1) {
          imagesContainer.classList.add("transition-completed");
          return;
        }

        productSlideImages.forEach(slide => {
          slide.style.removeProperty("object-fit");
          slide.style.objectPosition = "top";
        });

        productSlideVideos.forEach(slide => {
          slide.style.removeProperty("object-fit");
          slide.style.objectPosition = "top";
          slide.closest(".product__swiper-slide").style.alignItems = "flex-start";
        });
      } else if (window.innerWidth < 1415 && window.innerWidth >= 949) {
        productSlideImages.forEach(slide => {
          slide.style.removeProperty("object-fit");
          slide.style.objectFit = "contain";
          slide.style.objectPosition = "top";
        });

        productSlideVideos.forEach(slide => {
          slide.style.removeProperty("object-fit");
          slide.style.objectFit = "contain";
          slide.style.objectPosition = "top";
        });
      } else {
        const aspectRatio = productSwiper.offsetWidth / productSwiper.offsetHeight;
        const newProductSwiperWidth = viewPortCustomHeight * aspectRatio;
        const imagesContainerWidth = imagesContainer.offsetWidth;
        const productSwiperPercentage = (newProductSwiperWidth / imagesContainerWidth) * 100;
        const isSingleMedia = imagesContainer.classList.contains("product__images--single-media");
        const isHeightValid = window.innerHeight > 700;

        productSlideImages.forEach(slide => {
          slide.style.objectFit = "cover";
        });
        productSlideVideos.forEach(slide => {
          slide.style.objectFit = "cover";
          const productSlide = slide.closest('.product__slide');
          if (productSlide) {
            productSlide.style.removeProperty('height');
          }
        });

        if (!isSingleMedia) {
          if (isHeightValid) {
            // imagesContainer.style.setProperty("grid-template-columns", `auto ${productSwiperPercentage}%`, "important");
          } else {
            calculateContentMargin();
            // imagesContainer.style.setProperty("grid-template-columns", `auto auto`, "important");
          }
        }
      }

      
      requestAnimationFrame(() => {
        if (resizeTriggered) {
          imagesContainer.classList.add("transition-completed");
          return;
        }

        function handleTransitionEnd() {
          imagesContainer.classList.add("transition-completed");
          imagesContainer.removeEventListener("transitionend", handleTransitionEnd);
        }

        // imagesContainer.addEventListener("transitionend", handleTransitionEnd);
        imagesContainer.classList.add("transition-completed");
      });
    }

    function isDesktopDevice() {
      const userAgent = navigator.userAgent.toLowerCase();
      const isMobileUserAgent = /mobile|android|iphone|ipad|tablet|kindle|silk/.test(userAgent);
      const isSmallScreen = window.innerWidth < 1024;
      const isTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0;
      const isLandscape = window.matchMedia("(orientation: landscape)").matches;

      return !(isMobileUserAgent || isSmallScreen || isTouch) || !isLandscape;
    }

    function adjustSwiperWidth() {
      const productSwiper = document.querySelector(".swiper-container.product__swiper");
      productSwiper.style.width = "fit-content";
    }

    let isCalculatingMargin = false;
    
    function calculateContentMargin() {
      const [thumbsContainer, productSwiper, productContent, productPage] = [
        document.querySelector(pdpSelectors.thumbsContainer),
        document.querySelector(pdpSelectors.productSwiperActiveSlide),
        document.querySelector(pdpSelectors.productContent),
        document.querySelector(pdpSelectors.productPage),
      ];

      const singleMediaImageContainer = productPage.querySelector(".product__images.product__images--single-media");
    
      if (!thumbsContainer || !productSwiper || !productContent || !productPage) return;

      if (isCalculatingMargin) {
        return;
      }
      isCalculatingMargin = true;

      // if (!isDesktopDevice()) {
      //   productContent.style.marginLeft = "0";
      //   productContent.classList.add("transition-completed");
      //   isCalculatingMargin = false;
      //   return;
      // }

      productContent.classList.remove("transition-completed");
      productContent.style.marginLeft = "0";
    
      setTimeout(() => {
        const swiperRect = productSwiper.getBoundingClientRect();
        const contentRect = productContent.getBoundingClientRect();
        const pageRect = productPage.getBoundingClientRect();
    
        const swiperRight = swiperRect.right;

        const contentLeft = contentRect.left;
        const contentRight = contentRect.right;
        const pageRight = pageRect.right;
    
        const marginLeftNeeded = (pageRight - contentRight - contentLeft + swiperRight) / 2;
    
        productContent.style.marginLeft = marginLeftNeeded + "px";
        productContent.classList.add("transition-completed");
    
        const newRect = productContent.getBoundingClientRect();
        const newLeftSpacing = newRect.left - swiperRight;
        const newRightSpacing = pageRight - newRect.right;
    
        if (Math.round(newLeftSpacing) !== Math.round(newRightSpacing)) {
          productContent.style.marginLeft = "0px";
    
          const marginLeftRecalc = (pageRight - contentRight - contentLeft + swiperRight) / 2;
          productContent.style.marginLeft = marginLeftRecalc + "px";
        }
        isCalculatingMargin = false;
      }, 100);
    }

    function productImagesTransitionObserver() {
      const targetElement = document.querySelector(".product__images");

      if (!targetElement) return;

      let transitionCount = 0;
      const runTimes = 1;

      // function calculateContentMarginOnTransitionEnd(event) {
      //   if (event.target === targetElement) {
      //     transitionCount++;
      //     requestAnimationFrame(() => {
      //       calculateContentMargin();
      //     });

      //     if (transitionCount >= runTimes) {
      //       targetElement.removeEventListener("transitionend", calculateContentMarginOnTransitionEnd);
      //     }
      //   }
      // }

      // targetElement.addEventListener("transitionend", calculateContentMarginOnTransitionEnd);

      targetElement.addEventListener("transitionend", event => {
        if (event.target === targetElement) {
          requestAnimationFrame(() => {
            centerFormWrapper();
          });
        }
      });

      if (window.matchMedia("(min-width: 750px) and (orientation: portrait)").matches) {
        const productContent = document.querySelector(pdpSelectors.productContent);
        const formWrapper = productContent.querySelector(".form__wrapper");
        if (productContent) {
          productContent.style.opacity = 1;
          centerFormWrapper();
        }
      }
    }

    function setupBnplExpand() {
      let isExpanded = false;
    
      const expandIcon = document.querySelector(".bnpl-expand-icon");
      const termsElement = document.querySelector(".bnpl-terms.shop-pay-terms");
    
      if (!termsElement || !expandIcon) return; 
    
      function toggleExpand() {
        isExpanded = !isExpanded;
        termsElement.style.display = isExpanded ? "block" : "none";
        expandIcon.style.transform = isExpanded ? "rotate(180deg)" : "rotate(0deg)";
      }
    
      // On Click
      expandIcon.addEventListener("click", toggleExpand);
    
      // Keyboard support (Enter & Space)
      expandIcon.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          toggleExpand();
        }
      });
    }
    
    setupBnplExpand();


    function setupAccordionExpands() {
      const expandGroups = [
        {
          iconSelector: '.bnpl-expand-icon',
          contentSelector: '.bnpl-terms.shop-pay-terms'
        },
        ...Array.from(document.querySelectorAll('.product-accordion-item')).map((item) => ({
          iconSelector: null,
          contentSelector: null,
          custom: true,
          item: item
        }))
      ];
    
      expandGroups.forEach((group) => {
        let isExpanded = false;
        let expandIcon, content;
    
        if (group.custom) {
          expandIcon = group.item.querySelector('.pdp-accordion-expand-icon');
          content = group.item.querySelector('.pdp-accordion-content');
        } else {
          expandIcon = document.querySelector(group.iconSelector);
          content = document.querySelector(group.contentSelector);
        }
    
        if (!expandIcon || !content) return;
    
        const toggleExpand = () => {
          isExpanded = !isExpanded;
          content.style.display = isExpanded ? 'block' : 'none';
          expandIcon.style.transform = isExpanded ? 'rotate(180deg)' : 'rotate(0deg)';
        };
    
        expandIcon.addEventListener('click', toggleExpand);
    
        expandIcon.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggleExpand();
          }
        });
      });
    }
    
    setupAccordionExpands();
    
    

    function insertAccordionContent() {
      const accordionContent = document.querySelector(".product-accordion-content");
      const bnplTerm = document.querySelector(".bnpl-terms.shop-pay-terms");

      if (!accordionContent || !bnplTerm) return;

      bnplTerm.innerHTML += accordionContent.innerHTML;
    }

    insertAccordionContent();




    function imageMobileZoom(sliderElement) {
      let imageElementScale = 1;
      let isZooming = false;
      let isDragging = false;
      let panOffset = { x: 0, y: 0 };
      let lastTapTime = 0;
      let start = {};
    
      const image = sliderElement.querySelector("img");
      const swiperInstance = productSwiper; // Ensure Swiper instance
    
      function clamp(value, min, max) {
        return Math.min(Math.max(value, min), max);
      }
    
      function applyTransform() {
        image.style.transform = `translate3d(${panOffset.x}px, ${panOffset.y}px, 0) scale(${imageElementScale})`;
      }
    
      function disableSwiper() {
        if (swiperInstance) swiperInstance.allowTouchMove = false;
      }
    
      function enableSwiper() {
        if (swiperInstance) swiperInstance.allowTouchMove = true;
      }
    
      // **Touch Start**
      sliderElement.addEventListener("touchstart", (event) => {
        if (event.touches.length === 2) {
          disableSwiper();
          event.preventDefault();
          isZooming = true;
    
          start.image = image;
          start.distance = Math.hypot(
            event.touches[0].pageX - event.touches[1].pageX,
            event.touches[0].pageY - event.touches[1].pageY
          );
          start.midpoint = {
            x: (event.touches[0].pageX + event.touches[1].pageX) / 2,
            y: (event.touches[0].pageY + event.touches[1].pageY) / 2,
          };
          start.initialScale = imageElementScale;
    
          // Convert touch midpoint to relative position within image
          const rect = image.getBoundingClientRect();
          start.relativeMidpoint = {
            x: (start.midpoint.x - rect.left) / rect.width,
            y: (start.midpoint.y - rect.top) / rect.height,
          };
        } else if (imageElementScale > 1 && event.touches.length === 1) {
          disableSwiper();
          isDragging = true;
          const touch = event.touches[0];
          start.drag = { x: touch.pageX - panOffset.x, y: touch.pageY - panOffset.y };
        }
      });
    
      // **Touch Move (Pinch & Pan)**
      sliderElement.addEventListener("touchmove", (event) => {
        if (isZooming && event.touches.length === 2) {
          event.preventDefault();
          disableSwiper();
    
        // Inside "if (isZooming && event.touches.length === 2) { ... }":

          const containerRect = sliderElement.getBoundingClientRect();
          const currentDistance = Math.hypot(
            event.touches[0].pageX - event.touches[1].pageX,
            event.touches[0].pageY - event.touches[1].pageY
          );

          const pinchRatio = currentDistance / start.distance;
          const newScale = clamp(start.initialScale * pinchRatio, 1, 2.5);

          // 1) Calculate the scaled width/height of the image
          const newWidth = image.clientWidth * newScale;
          const newHeight = image.clientHeight * newScale;

          // 2) Figure out how far the image can move inside the container
          const maxOffsetX = (newWidth - containerRect.width) / 2;
          const maxOffsetY = (newHeight - containerRect.height) / 2;

          // 3) Recompute panOffset so we zoom into the pinch midpoint
          panOffset.x = -((start.relativeMidpoint.x - 0.5) * newWidth);
          panOffset.y = -((start.relativeMidpoint.y - 0.5) * newHeight);

          // 4) Clamp so the image never overflows the container
          panOffset.x = clamp(panOffset.x, -maxOffsetX, maxOffsetX);
          panOffset.y = clamp(panOffset.y, -maxOffsetY, maxOffsetY);

          imageElementScale = newScale;
          applyTransform();





        } else if (isDragging && event.touches.length === 1) {
          event.preventDefault();
          disableSwiper();
          const touch = event.touches[0];
          panOffset.x = touch.pageX - start.drag.x;
          panOffset.y = touch.pageY - start.drag.y;
    
          // Prevent panning outside image bounds
          const maxPanX = ((imageElementScale - 1) * image.clientWidth) / 2;
          const maxPanY = ((imageElementScale - 1) * image.clientHeight) / 2;
          panOffset.x = clamp(panOffset.x, -maxPanX, maxPanX);
          panOffset.y = clamp(panOffset.y, -maxPanY, maxPanY);
    
          applyTransform();
        }
      });
    
      // **Touch End (Reset dragging & zoom logic)**
      sliderElement.addEventListener("touchend", (event) => {
        if (event.touches.length === 0) {
          // Only reset zoom state when all fingers are lifted
          isDragging = false;
          isZooming = false;
          enableSwiper();
      
          // Double-tap logic
          const currentTime = Date.now();
          if (currentTime - lastTapTime < 300) {
            event.preventDefault();
            const touch = event.changedTouches[0];
      
            if (imageElementScale === 1) {
              imageElementScale = 2.5;
      
              const rect = image.getBoundingClientRect();
              const relX = (touch.clientX - rect.left) / rect.width;
              const relY = (touch.clientY - rect.top) / rect.height;
      
              panOffset.x = clamp(-((relX - 0.5) * rect.width), -rect.width / 2, rect.width / 2);
              panOffset.y = clamp(-((relY - 0.5) * rect.height), -rect.height / 2, rect.height / 2);
            } else {
              imageElementScale = 1;
              panOffset = { x: 0, y: 0 };
            }
            applyTransform();
          }
          lastTapTime = currentTime;
        }
      });      
    
      // Prevent swiper from sliding while zoomed
      sliderElement.addEventListener("touchstart", (event) => {
        if (imageElementScale > 1) {
          disableSwiper();
          event.stopPropagation();
        }
      });
    
      sliderElement.addEventListener("dblclick", (event) => event.preventDefault());
    }
    
    // **Initialize Zoom on Active Slide**
    function initImageMobileZoom() {
      if (window.innerWidth < 750) {
        const activeSlide = document.querySelector(".swiper-slide.product__swiper-slide.swiper-slide-active");
        if (activeSlide) {
          imageMobileZoom(activeSlide);
        }
      }
    }
    

    function alignATCSection(isCountdownVisible) {
      const atcSection = document.querySelector(".product__submit__price-and-atc");

      if (!atcSection) return;

      const priceSale = atcSection.querySelector(".product__price--sale");
      const countdownLow = atcSection.querySelector(".variant__countdown");
      const preOrderMsg = atcSection.querySelector(".pre-order-msg");

      const isAtcSectionWidthValid = atcSection.offsetWidth < 374;
      const isPriceSaleVisible = priceSale && window.getComputedStyle(priceSale).display !== "none";
      const isCountdownLowVisible = countdownLow && window.getComputedStyle(countdownLow).display !== "none";
      const isPreOrderMsgVisible = preOrderMsg && window.getComputedStyle(preOrderMsg).display !== "none";

      const blockEnd = atcSection.querySelector(".product__submit__block-end");

      if (!blockEnd) return;

      if ((isPriceSaleVisible && isCountdownLowVisible && isPreOrderMsgVisible && isCountdownVisible) || (atcSection.offsetWidth < 374 && isCountdownLowVisible && isPreOrderMsgVisible && isCountdownVisible && !isPriceSaleVisible)) {
        blockEnd.style.flexDirection = "column-reverse";
      } else {
        blockEnd.style.flexDirection = "row";
      }
    }

    function observeVariantCountdown() {
      const preOrderMsgElement = document.querySelector(".pre-order-msg");
    
      if (!preOrderMsgElement) return;
    
      let lastState = preOrderMsgElement.classList.contains("show");
    
      const observer = new MutationObserver(() => {
        const isPreOrderMsgVisible = preOrderMsgElement.classList.contains("show");
        if (isPreOrderMsgVisible !== lastState) {
          lastState = isPreOrderMsgVisible;
          alignATCSection(isPreOrderMsgVisible);
        }
      });
    
      observer.observe(preOrderMsgElement, { attributes: true, attributeFilter: ["class"] });
    }

    observeVariantCountdown();

    function atcContainerClick() {
      const atcContainer = document.querySelector(".product__submit__price-and-atc");
      const addToCartButton = document.querySelector("#AddToCart");
      const klaviyoBtn = document.querySelector(".klaviyo_btn.klaviyo-bis-trigger");

      if (atcContainer && addToCartButton && klaviyoBtn) {
        let eventTriggered = false;

        function handleClick(event, isKeyboard = false) {
          if (eventTriggered) return;
          eventTriggered = true;
    
          if (isKeyboard) event.preventDefault();
    
          //console.log("Triggering Add to Cart or Get Notified...");
    
          if (!klaviyoBtn.classList.contains("hide_klaviyo_btn")) {
            klaviyoBtn.click();
    
            // ✅ Focus the iframe after it loads
            const interval = setInterval(() => {
              const iframe = document.querySelector("#klaviyo-bis-iframe");
              if (iframe) {
                iframe.setAttribute("tabindex", "0"); // Ensure it's focusable
                //console.log("Iframe found, focusing...");
                iframe.focus();
                clearInterval(interval);
              }
            }, 100);
    
            // ✅ Detect when the iFrame gets `display: none`
            const iframe = document.querySelector("#klaviyo-bis-iframe");
            if (iframe) {
              const observer = new MutationObserver(() => {
                if (window.getComputedStyle(iframe).display === "none") {
                  //console.log("Klaviyo modal closed, returning focus to BIS button...");
                  klaviyoBtn.focus();
                  observer.disconnect(); // Stop observing
                }
              });
    
              observer.observe(iframe, { attributes: true, attributeFilter: ["style"] });
            }
          } else {
            addToCartButton.click();
          }
    
          setTimeout(() => {
            eventTriggered = false;
          }, 200);
        }
    
        atcContainer.addEventListener("click", handleClick, { once: false });
    
        // Attach keydown event for Enter/Space
        atcContainer.addEventListener("keydown", (event) => {
          if (event.key === "Enter" || event.key === " ") {
            handleClick(event, true);
          }
        });
        
        // Klaviyo button keyboard accessibility
        if (klaviyoBtn) {
          klaviyoBtn.setAttribute("tabindex", "0");
          
          klaviyoBtn.addEventListener("keydown", (event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              klaviyoBtn.click();
              
              const interval = setInterval(() => {
                const iframe = document.querySelector("#klaviyo-bis-iframe");
                if (iframe) {
                  iframe.setAttribute("tabindex", "0");
                  iframe.focus();
                  clearInterval(interval);
                }
              }, 100);
            }
          });
        }
      }
    }
    
    // Run the function
    atcContainerClick();

    function centerFormWrapper() {
      const formWrapper = document.querySelector(".form__wrapper");
      const productContent = document.querySelector(".product__content");

      if (!formWrapper || !productContent) return;

      const parentHeight = productContent.offsetHeight;
      const formWrapperHeight = formWrapper.offsetHeight;
      const marginTop = (parentHeight - formWrapperHeight) / 2;

      if (window.innerWidth > 749) {
        formWrapper.style.marginTop = `${marginTop}px`;
      } else {
        formWrapper.style.removeProperty("margin-top");
      }
    }

    function setupCartDrawerAccessibility() {
      const addToCartButton = document.querySelector("#AddToCart");
      const cartDrawer = document.querySelector("#cart-drawer");
      const cartDrawerHead = document.querySelector(".cart-drawer__head");
      const closeCartButton = document.querySelector(".cart-drawer__close");
      const mobileCartIcon = document.querySelector(".header__mobile .navlink--cart--icon");
      const desktopCartIcon = document.querySelector(".header__desktop .navlink--cart--icon");
      
      if (!addToCartButton || !cartDrawer || !closeCartButton) return;
    
      // Track how the cart was opened
      let cartOpenedBy = null; // 'atc' or 'cart-icon'
    
      // Listen for ATC clicks
      if (addToCartButton) {
        addToCartButton.addEventListener('click', () => {
          cartOpenedBy = 'atc';
        });
      }
    
      // Listen for cart icon clicks (both mobile and desktop)
      [mobileCartIcon, desktopCartIcon].forEach(icon => {
        if (icon) {
          icon.addEventListener('click', () => {
            cartOpenedBy = 'cart-icon';
          });
        }
      });
    
      function closeCart() {
        cartDrawer.classList.remove("is-open");
        cartDrawerHead.classList.remove("is-animated");
        cartDrawerHead.classList.add("is-hiding");
    
        setTimeout(() => {
          returnFocusAfterClose();
        }, 500); 
      }
    
      function returnFocusAfterClose() {
        if (cartOpenedBy === 'atc' && addToCartButton) {
          addToCartButton.focus();
        } 
        else if (cartOpenedBy === 'cart-icon') {
          const isMobile = window.innerWidth < 750;
          const focusTarget = isMobile ? mobileCartIcon : desktopCartIcon;
          if (focusTarget) focusTarget.focus();
        }
        
        // Reset tracking
        cartOpenedBy = null;
      }
    
      closeCartButton.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          closeCart();
        }
      });
    
      // Also handle when cart is closed via other methods (e.g., overlay click)
      document.addEventListener('cart:closed', returnFocusAfterClose);
    }

    setupCartDrawerAccessibility();

    function fixedATCSection() {
      const atcSection = document.querySelector(".product__submit-sticky");
      const formHolder = document.querySelector(".product__form__holder");
  
      if (!atcSection || !formHolder) return;
  
      let isFixed = true;
      atcSection.classList.add("fixed");
  
      const handleScroll = () => {
          const rect = formHolder.getBoundingClientRect();
          const hasScrolledPast = rect.bottom < 0;
  
          // Trigger fixed a bit earlier when user is near the top (e.g., within 50px)
          if (window.scrollY <= 100) {
              if (!isFixed) {
                  atcSection.classList.add("fixed");
                  isFixed = true;
              }
              return;
          }
  
          if (hasScrolledPast) {
              if (isFixed) {
                  atcSection.classList.remove("fixed");
                  isFixed = false;
              }
              return;
          }
  
          const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
          if (!isVisible && !isFixed) {
              atcSection.classList.add("fixed");
              isFixed = true;
          } else if (isVisible && isFixed) {
              atcSection.classList.remove("fixed");
              isFixed = false;
          }
      };
  
      window.addEventListener("scroll", handleScroll);
    }  
    
    if (window.innerWidth >= 750) {
      productImagesTransitionObserver();
    }

    window.addEventListener("resize", () => {
      resizeTriggered = true;
      applyPdpZoomImageHeightFix();
      if (window.innerWidth >= 750) {
        productImagesTransitionObserver();
        calculateContentMargin();
        centerFormWrapper();
      }
      if (window.matchMedia("(min-width: 750px) and (orientation: portrait)").matches) {
        document.querySelector(".product__images")?.style.removeProperty("grid-template-columns");
        document.querySelector(".swiper-container.product__swiper")?.style.removeProperty("width");
        productThumbnailContainer.style.display = "grid";
      } else if (window.matchMedia("(min-width: 750px) and (orientation: landscape)").matches) {
        productThumbnailContainer.style.display = "grid";
        adjustSwiperWidth();
        setupZoom();
        applyContainAndScrollableIfNeeded();
        adjustGridTemplateColumns();
      } else {
        const productSwiper = document.querySelector(pdpSelectors.productSwiper);
        const productContent = document.querySelector(pdpSelectors.productContent);
        productThumbnailContainer.style.display = "none";
        productSwiper.style.width = "100%";
        productContent.style.marginLeft = "0";
        const zoomElements = document.querySelectorAll(".product__swiper-wrapper .zoomable-image");
        zoomElements.forEach(element => disableZoom(element));
      }
    });
  });
})();
// End: Product page media customizations


// Start: Added To Cart Customizations
document.addEventListener("DOMContentLoaded", () => {
  initAddedToCartBehavior();
});

function initAddedToCartBehavior() {
  const addToCartButton = document.querySelector("#AddToCart");
  const submitSection = document.querySelector(".product__submit__buttons");

  if (!addToCartButton || !submitSection) return;

  addToCartButton.addEventListener("click", () => {
    const atcButtonText = addToCartButton.textContent;
    setTimeout(() => {
      const errorMsg = document.querySelector(".add-to-bag-size-selector");
      const errorsHidden = errorMsg ? errorMsg.classList.contains("add-to-bag-error-msg") : false;
      const hasNotifyMeClass = addToCartButton.classList.contains("notify-me-btn");

      if (errorsHidden && !hasNotifyMeClass) {
        // Change button text & remove all click interactions from the parent container
        addToCartButton.textContent = "ADDED TO BAG";
        submitSection.style.pointerEvents = "none";

        // Change button text back to inital state
        setTimeout(() => {
          addToCartButton.textContent = atcButtonText;
        }, 1000);
      }
    }, 500);
  });

  // Watch for changes in the button text and enable pointer-events if the text changes
  const observer = new MutationObserver(() => {
    if (addToCartButton.textContent.trim() !== "ADDED TO BAG") {
      // Re-enable interactions
      submitSection.style.pointerEvents = "auto";
    }
  });

  // Observe text changes inside the button
  observer.observe(addToCartButton, { childList: true, subtree: true });
}
// End: Added To Cart Customizations

document.addEventListener("DOMContentLoaded", function () {
  function addCheckboxKeydownListeners() {
      document.querySelectorAll(".collection-nav input[type='checkbox']").forEach((checkbox) => {
          checkbox.removeEventListener("keydown", handleCheckboxKeydown); // Prevent duplicates
          checkbox.addEventListener("keydown", handleCheckboxKeydown);
      });
  }

  function handleCheckboxKeydown(event) {
      if (event.key === "Enter" || event.key === " ") {
          event.preventDefault(); // Prevent scrolling on Space key
          event.target.click(); // Simulate a real click event
      }
  }

  // Initial binding when the page loads
  addCheckboxKeydownListeners();

  // MutationObserver to detect changes in the filter container
  const filterContainer = document.getElementById("filter-groups");

  if (filterContainer) {
      const observer = new MutationObserver(() => {
          setTimeout(addCheckboxKeydownListeners, 100); // Small delay to ensure filters are fully loaded
      });

      observer.observe(filterContainer, {
          childList: true, // Detect when checkboxes are replaced
          subtree: true,   // Detect deeper changes inside filter groups
      });
  }


  // START: Safari Focus Fix for Cart Drawer NLSB-179

  // Detect "real" Safari (not Chrome on iOS or other WebKit)
  // — you can tweak this regex if needed
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  if (isSafari) {
    let lastCartFocusSelector = null;

    function handleFocusPreservation(e) {
      const cartDrawer = document.querySelector('#cart-drawer');
      if (!cartDrawer?.classList.contains('is-open')) return;
      if (!cartDrawer.contains(e.target)) return;

      const button = e.target.closest('[data-quantity-button]');
      if (!button) return;

      const holder  = button.closest('[data-quantity-holder]');
      const item    = button.closest('.cart__item');
      const title   = item?.querySelector('.cart__item__title a')?.textContent?.trim();

      let color = null, size = null;
      item?.querySelectorAll('.cart__item__selected-options').forEach(block => {
        const label = block.querySelector('strong')?.textContent?.trim();
        const value = block.querySelector('span')?.textContent?.trim();
        if (label === 'COLOR:') color = value;
        if (label === 'SIZE:')  size  = value;
      });

      const isPlus = button.hasAttribute('data-quantity-plus');
      if (title) {
        lastCartFocusSelector = { title, color, size, type: isPlus ? 'plus' : 'minus' };
        // console.log('[Safari-Focus] Saved context:', lastCartFocusSelector);
      }
    }

    document.addEventListener('click',   handleFocusPreservation);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') handleFocusPreservation(e);
    });
    document.addEventListener('keydown', (e) => {
      if (!isSafari) return;

      if (e.key === 'Enter' && e.target.matches('[data-quantity-field]')) {
        lastCartFocusSelector = { fallback: true };
        console.log('[Safari-Focus] Saved context: custom input Enter');
      }

      // Handle Tab key too
      if (e.key === 'Tab' && e.target.matches('[data-quantity-field]')) {
        lastCartFocusSelector = { fallback: true };
        console.log('[Safari-Focus] Saved context: custom input Tab');
      }
    });

    const cartDrawer = document.querySelector('#cart-drawer');
    if (cartDrawer) {
      let debounceTimeout;
      const observer = new MutationObserver(() => {
        if (!lastCartFocusSelector || !cartDrawer.classList.contains('is-open')) return;
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(() => {
          const closeBtn = cartDrawer.querySelector('.cart-drawer__close[data-cart-toggle]');

          if (lastCartFocusSelector?.fallback && closeBtn) {
            // user typed a number and hit Enter → focus Close button
            closeBtn.focus({ preventScroll: true });
            console.log('[Safari-Focus] 🔁 Fallback focus → close button');
          } else {
            // all other cases → focus the drawer itself
            if (closeBtn) {
              closeBtn.focus({ preventScroll: true });
              console.log('[Safari-Focus] 🔁 Fallback focus → close button (default)');
            } else {
              cartDrawer.focus({ preventScroll: true });
              console.log('[Safari-Focus] 🔁 Fallback focus → #cart-drawer (no close button found)');
            }

          }

          lastCartFocusSelector = null;
        }, 500);
      });

      observer.observe(cartDrawer, { childList: true, subtree: true });
    }
  }

  // END: Safari Focus Fix for Cart Drawer NLSB-179




});


window.addEventListener('beforeunload', () => {
  sessionStorage.removeItem('variant_url_updated_once');
});

//display variant-specific badges and colors based on the selected variant.
document.addEventListener("DOMContentLoaded", function () {
  // Parse variant data
  let variantData = {};
  try {
    const variantDataScript = document.getElementById("variant-data");
    if (variantDataScript) {
      variantData = JSON.parse(variantDataScript.textContent);
    }
  } catch (error) {
    console.error("Error parsing variant-data JSON:", error);
  }
 
  // Function to clean badge text
  function cleanBadgeText(badgeText) {
    if (!badgeText) return "";
    try {
      const decodedText = new DOMParser()
        .parseFromString(`<!DOCTYPE html><body>${badgeText}`, "text/html")
        .body.textContent;
      if (decodedText.startsWith("[") && decodedText.endsWith("]")) {
        const parsed = JSON.parse(decodedText);
        return Array.isArray(parsed) ? parsed[0] : parsed;
      }
      return decodedText;
    } catch (error) {
      console.warn("Error cleaning badge text:", badgeText, error);
      return badgeText;
    }
  }
 
  // Function to update badge and color
  function updateVariantDisplay(variantId) {
    let badgeElement = document.querySelector(".product__ss-badge[data-variant-id]");
    // let colorElement = document.querySelector(".product__title-color");
 
    const variantIdStr = String(variantId);
    const variantInfo = variantData[variantIdStr] || {
      variant_badge: "",
      product_badge: "",
      color: "",
      has_variant_badge: false,
      has_product_badge: false,
    };
 
    // Remove existing badge and color elements to avoid duplicates
    if (badgeElement) {
      badgeElement.remove();
    }
    // if (colorElement) {
    //   colorElement.remove();
    // }
 
    const titleWrapper = document.querySelector(".product__title-and-badge-wrapper");
 
    if (variantInfo.has_variant_badge) {
      // Show variant badge and color
      // colorElement = document.createElement("div");
      // colorElement.className = "product__title-color";
      // colorElement.style.display = "inline";
      // colorElement.textContent = variantInfo.color || "";
      // titleWrapper.appendChild(colorElement);
 
      badgeElement = document.createElement("div");
      badgeElement.className = "product__ss-badge";
      badgeElement.setAttribute("data-variant-id", variantIdStr);
      badgeElement.style.display = "inline";
      badgeElement.textContent = cleanBadgeText(variantInfo.variant_badge);
      titleWrapper.appendChild(badgeElement);
    } else if (variantInfo.has_product_badge) {
      // Show product badge only
      badgeElement = document.createElement("div");
      badgeElement.className = "product__ss-badge";
      badgeElement.setAttribute("data-variant-id", variantIdStr);
      badgeElement.style.display = "inline";
      badgeElement.textContent = cleanBadgeText(variantInfo.product_badge);
      titleWrapper.appendChild(badgeElement);
    }
    // If neither badge exists, do nothing (no elements are added)
  }
 
  // Initialize with current variant
  const badgeElement = document.querySelector(".product__ss-badge[data-variant-id]");
  if (badgeElement) {
    const initialVariantId = badgeElement.getAttribute("data-variant-id");
    if (initialVariantId) {
      updateVariantDisplay(initialVariantId);
    }
  }
 
  // Handle variant changes
  const variantSelectors = document.querySelectorAll(
    'input[name="id"], select[name="id"], input[name*="option"]'
  );
 
  variantSelectors.forEach((selector) => {
    selector.addEventListener("change", function () {
      const form = selector.closest("form");
      const idSelector = form?.querySelector('input[name="id"], select[name="id"]');
      if (idSelector?.value) {
        updateVariantDisplay(idSelector.value);
      }
    });
  });
 
  // Handle swatch clicks
  document.querySelectorAll('.swatch input[type="radio"]').forEach((swatch) => {
    swatch.addEventListener("change", function () {
      const variantId = this.getAttribute("data-variant-id") || this.value;
      if (variantId) {
        updateVariantDisplay(variantId);
      }
    });
  });
});
// Start: Breadcrumb Navigation
(function() {
  let desktopListenersAttached = false;
  let mobileListenersAttached = false;
  let collectionListenersAttached = false;

  function initBreadcrumbsNavigation() {
    const isCollectionPage = location.pathname.includes('/collections/') && !location.pathname.includes('/products/');
    const isProductPage    = location.pathname.includes('/products/');

    let navType = 'navigate';
    if (performance.getEntriesByType) {
      const entries = performance.getEntriesByType('navigation');
      if (entries.length) navType = entries[0].type;
    } else if (performance.navigation) {
      const map = ['navigate','reload','back_forward','prerender'];
      navType = map[performance.navigation.type] || 'navigate';
    }

    const params = new URLSearchParams(location.search);
    const flag = params.get('pdp_nav');
    const nonPdpFlag = params.get('non_pdp_nav');
    const productClicked = sessionStorage.getItem('pdp_product_clicked') === 'true';
    const hasStored = !!localStorage.getItem('pdp_breadcrumbs');

    let storedData = {};
    try {
      storedData = JSON.parse(localStorage.getItem('pdp_breadcrumbs')) || {};
    } catch (e) {}
    const storedSelectedProduct = storedData.selectedProduct;

    const currentEl = document.querySelector('.breadcrumbs--pdp__current');
    const currentHandle = currentEl
      ? currentEl.getAttribute('data-breadcrumbs-current-product-handle')
      : null;

    if (isCollectionPage) {
      if (navType !== 'back_forward' && flag !== 'clicked' && nonPdpFlag !== 'clicked') {
        localStorage.removeItem('pdp_breadcrumbs');
        sessionStorage.removeItem('pdp_product_clicked');
      }
    }

    if (flag === 'clicked') {
      const clean = location.origin + location.pathname + location.hash;
      history.replaceState(null, '', clean);
    }

    setupNavigationForCurrentDevice();
    setupCollectionProductListeners();
    window.addEventListener('resize', debounce(setupNavigationForCurrentDevice, 250));

    if (isProductPage) {
      setupBreadcrumbsClickEvents();

      if (
        productClicked &&
        (flag === 'clicked' || hasStored) &&
        storedSelectedProduct === currentHandle
      ) {
        displayNavigationPath();
      } else {
        hideDefaultBreadcrumbsIfOnlyProduct();
      }
    }
  }

  function hideDefaultBreadcrumbsIfOnlyProduct() {
    const nav = document.querySelector('nav.breadcrumbs--pdp');
    if (!nav) return;
    const pathSpan = nav.querySelector('.breadcrumbs--pdp__navigation-path');
    if (!pathSpan || pathSpan.textContent.trim() === '') {
      nav.style.display = 'none';
    }
  }

  function navigateWithFlag(e, href, cb) {
    e.preventDefault();
    if (cb) cb();
    window.location.href = href + (href.includes('?') ? '&' : '?') + 'pdp_nav=clicked';
  }

  function setupNavigationClickTracking() {
    document.querySelectorAll('.navlink--child').forEach(link => {
      link.addEventListener('click', function(e) {
        navigateWithFlag(e, this.href, () => {
          const subC = this.querySelector('.navtext').textContent.trim();
          const parentD = this.closest('.header__dropdown');
          if (!parentD) return;
          const trigger = document.querySelector(`[data-hover-disclosure-toggle="${parentD.id}"]`);
          const parentLinkEl = trigger.querySelector('a.navlink--toplevel');
          const data = getBreadcrumbData();
          data.parent = trigger.querySelector('.navtext').textContent.trim();
          data.parentLink = parentLinkEl ? parentLinkEl.href : '';
          data.subcategory = subC;
          data.path = this.getAttribute('href');
          saveBreadcrumbData(data);
        });
      });
    });

    document.querySelectorAll('.navlink--toplevel').forEach(link => {
      link.addEventListener('click', function(e) {
        const href = this.href;
        if (!href.includes('/collections/')) return;
        navigateWithFlag(e, href, () => {
          const data = getBreadcrumbData();
          const txt = this.querySelector('.navtext').textContent.trim();
          const parentEl = this.closest('.menu__item');
          if (parentEl.classList.contains('parent')) {
            data.parent = txt;
            data.parentLink = href;
            data.subcategory = '';
            data.path = '';
          } else {
            data.parent = '';
            data.parentLink = '';
            data.subcategory = txt;
            data.path = href;
          }
          saveBreadcrumbData(data);
        });
      });
    });
  }

  function setupBreadcrumbsClickEvents() {
    setTimeout(() => {
      document.querySelectorAll('.breadcrumbs--pdp__parent, .breadcrumbs--pdp__subcategory').forEach(link => {
        link.addEventListener('click', function(e) {
          navigateWithFlag(e, this.href, () => {
            const data = getBreadcrumbData();
            if (this.classList.contains('breadcrumbs--pdp__parent')) {
              data.parent = this.textContent.trim();
              data.parentLink = this.href;
              data.subcategory = '';
              data.path = '';
            } else {
              data.subcategory = this.textContent.trim();
              data.path = this.href;
            }
            saveBreadcrumbData(data);
          });
        });
      });
    }, 250);
  }

  function setupMobileNavigationClickTracking() {
    let currentMobileParent = '';
    let currentMobileParentLink = '';

    document.querySelectorAll('.sliderow[data-sliderule-open]').forEach(btn => {
      btn.addEventListener('click', function(e) {
        navigateWithFlag(e, this.href, () => {
          const titleEl = this.querySelector('.sliderow__title');
          if (!titleEl || !titleEl.childNodes.length) return;
          currentMobileParent = titleEl.childNodes[0].nodeValue.trim();
          currentMobileParentLink = (this.querySelector('a.sliderow__title')||{}).href || '';
          const data = getBreadcrumbData();
          data.parent = currentMobileParent;
          data.parentLink = currentMobileParentLink;
          data.subcategory = '';
          data.path = '';
          saveBreadcrumbData(data);
        });
      });
    });

    document.querySelectorAll('.sliderow__links .sliderow__title').forEach(link => {
      link.addEventListener('click', function(e) {
        navigateWithFlag(e, this.href, () => {
          const subC = this.textContent.trim();
          const href = this.href;
          let parentL = currentMobileParentLink;
          if (!parentL) {
            const allLink = this.closest('.sliderow__links').querySelector('.sliderow__title[href*="/collections/all"]');
            parentL = allLink ? allLink.href : '';
          }
          const data = getBreadcrumbData();
          data.parent = currentMobileParent;
          data.parentLink = parentL;
          data.subcategory = subC;
          data.path = href;
          saveBreadcrumbData(data);
        });
      });
    });

    document.querySelectorAll('.sliderule__wrapper > .sliderow > a.sliderow__title').forEach(link => {
      if (!link.closest('.mobile__menu__dropdown')) {
        link.addEventListener('click', function(e) {
          navigateWithFlag(e, this.href, () => {
            const href = this.href;
            const data = getBreadcrumbData();
            data.parent = '';
            data.parentLink = '';
            data.subcategory = this.textContent.trim();
            data.path = href;
            saveBreadcrumbData(data);
          });
        });
      }
    });
  }

  function enableMegaMenuClickTrigger() {
    document.querySelectorAll('[data-mega-trigger] > a.navlink--toplevel').forEach(anchor => {
      const parent = anchor.closest('[data-mega-trigger]');
      if (!parent) return;
      const dropdownId = parent.getAttribute('data-mega-trigger');
      const dropdown = document.getElementById(dropdownId);
      if (!dropdown) return;

      // Do not intercept clicks; allow navigation. Hover will still open via CSS/other handlers.

      document.addEventListener('click', evt => {
        if (parent.contains(evt.target)) return;
        parent.classList.remove('is-visible');
        dropdown.classList.remove('is-visible');
      });
    });
  }

  function setupCollectionProductListeners() {
    if (collectionListenersAttached) return;
    document.addEventListener('click', function(e) {
      const pl = e.target.closest('#CollectionLoop .product-item .product-link');
      if (!pl) return;
      const handle = extractProductHandleFromUrl(pl.href);
      const cur    = getBreadcrumbData();
      if (handle && cur.path) {
        sessionStorage.setItem('pdp_product_clicked','true');
        saveBreadcrumbData({
          selectedProduct: handle,
          parent: cur.parent || '',
          parentLink: cur.parentLink  || '',
          subcategory: cur.subcategory || '',
          path: cur.path || '',
          previousData: cur.previousData||{}
        });
      }
    });
    collectionListenersAttached = true;
  }

  function extractProductHandleFromUrl(url) {
    const m = url && url.match(/\/products\/([^\/?]+)/);
    return m ? m[1] : null;
  }

  function setupNavigationForCurrentDevice() {
    const isMobile = innerWidth < 749;
    if (isMobile && !mobileListenersAttached) {
      setupMobileNavigationClickTracking();
      mobileListenersAttached = true;
    } else if (!isMobile && !desktopListenersAttached) {
      setupNavigationClickTracking();
      enableMegaMenuClickTrigger();
      desktopListenersAttached = true;
    }
  }

  function saveBreadcrumbData(data) {
    const raw = localStorage.getItem('pdp_breadcrumbs');
    let ex = {};
    if (raw) {
      try { ex = JSON.parse(raw); } catch {}
    }
    const selB = ex.selectedProduct, selA = data.selectedProduct;
    const pathB = ex.path, pathA = data.path;
    const changed = (selB && selA && selB!==selA) || (selB && selA && pathB && pathB!==pathA);
    if (changed && (ex.parent||ex.subcategory)) {
      data.previousData = {
        selectedProduct: ex.selectedProduct,
        parent: ex.parent || '',
        parentLink: ex.parentLink || '',
        subcategory: ex.subcategory || '',
        path: ex.path || ''
      };
    } else if (ex.previousData && Object.keys(ex.previousData).length) {
      data.previousData = ex.previousData;
    }
    localStorage.setItem('pdp_breadcrumbs', JSON.stringify(data));
  }

  function getBreadcrumbData() {
    const raw = localStorage.getItem('pdp_breadcrumbs');
    if (raw) {
      try { return JSON.parse(raw); } catch {}
    }
    return {};
  }

  function displayNavigationPath() {
    const container = document.querySelector('.breadcrumbs--pdp__navigation-path');
    if (!container) return;

    const crumbs = getBreadcrumbData();
    let useData  = crumbs.previousData && crumbs.previousData.selectedProduct === crumbs.selectedProduct ? crumbs.previousData : crumbs;

    let html = '';
    if (useData.parent) {
      html += `<a href="${useData.parentLink||'#'}" class="breadcrumbs--pdp__parent">${useData.parent}</a>`;
      html += `<span class="breadcrumbs--pdp__separator">/</span>`;
    }
    if (useData.subcategory) {
      if (useData.path) {
        html += `<a href="${useData.path}" class="breadcrumbs--pdp__subcategory">${useData.subcategory}</a>`;
      } else {
        html += `<span class="breadcrumbs--pdp__subcategory">${useData.subcategory}</span>`;
      }
      html += `<span class="breadcrumbs--pdp__separator">/</span>`;
    }
    container.innerHTML = html;
  }

  function debounce(fn, ms) {
    let t;
    return () => {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBreadcrumbsNavigation);
  } else {
    initBreadcrumbsNavigation();
  }
  window.addEventListener('popstate', initBreadcrumbsNavigation);
})();
// End: Breadcrumb Navigation
// Start: Klaviyo Form Keyboard Accessibility
document.addEventListener("DOMContentLoaded", function() {
  const formSelectors = [
    { id: 'R9q9nz', name: 'popup form', selector: "[data-testid='klaviyo-form-R9q9nz']" },
    { id: 'RqpFi9', name: 'footer form', selector: "[data-testid='klaviyo-form-RqpFi9']" }
  ];
  
  function initKlaviyoFormAccessibility() {
    formSelectors.forEach(form => {
      const existingForm = document.querySelector(form.selector);
      if (existingForm) {
        setTimeout(() => setupFormAccessibility(existingForm, form.id, form.name), 500);
      }
    });
    
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          for (let i = 0; i < mutation.addedNodes.length; i++) {
            const node = mutation.addedNodes[i];
            if (!node.querySelector) continue;
            
            formSelectors.forEach(form => {
              const formElement = node.querySelector(form.selector);
              if (formElement) {
                setTimeout(() => setupFormAccessibility(formElement, form.id, form.name), 500);
              }
            });
          }
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function setupFormAccessibility(form, formId, formName) {
    if (!form) return;
    
    if (form.getAttribute('data-accessibility-processed') === 'true') return;
    form.setAttribute('data-accessibility-processed', 'true');
    
    const closeButton = formId === 'R9q9nz' ? document.querySelector(".klaviyo-close-form") : null;
    if (closeButton) {
      closeButton.setAttribute('tabindex', '0');
      closeButton.setAttribute('role', 'button');
      closeButton.setAttribute('aria-label', 'Close form');
      
      closeButton.addEventListener("keydown", function(event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          closeButton.click();
        }
      });
    }

    if (formId === 'RqpFi9') {
      const allInputs = document.querySelectorAll(`[data-testid*='${formId}'] input[type="radio"]`);
      allInputs.forEach(input => {
        input.setAttribute('tabindex', '-1');
      });
      
      const allLabels = document.querySelectorAll(`[data-testid*='${formId}'] label`);
      const radioLabels = Array.from(allLabels).filter(label => {
        return label.textContent && ['Womens', 'Mens', 'Both'].includes(label.textContent.trim());
      });
      
      radioLabels.forEach((label, index) => {
        const optionText = label.textContent.trim();
        
        label.setAttribute('tabindex', '0');
        // label.setAttribute('role', 'radio');
        
        // label.addEventListener('focus', () => {
        //   label.style.outline = '2px solid black';
        //   label.style.outlineOffset = '2px';
        // });
        
        label.addEventListener('blur', () => {
          label.style.outline = 'none';
        });
        
        label.addEventListener('keydown', function(event) {
          if (event.key === " " || event.key === "Enter") {
            event.preventDefault();
            event.stopPropagation();
            
            const radioInput = findAssociatedRadio(label, allInputs);
            if (radioInput && !radioInput.checked) {
              label.click();
            }
          } else if (event.key === "ArrowRight" || event.key === "ArrowDown") {
            event.preventDefault();
            const nextIndex = (index + 1) % radioLabels.length;
            radioLabels[nextIndex].focus();
          } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
            event.preventDefault();
            const prevIndex = (index - 1 + radioLabels.length) % radioLabels.length;
            radioLabels[prevIndex].focus();
          }
        });
      });
      
      const emailField = form.querySelector('input[type="email"]');
      if (emailField) {
        emailField.addEventListener('keydown', function(event) {
          if (event.key === "Enter") {
            event.preventDefault();
            const submitButton = form.querySelector('button[type="submit"]');
            if (submitButton) {
              submitButton.click();
            }
          }
        });
      }
      
      const formButtons = form.querySelectorAll("button");
      
      formButtons.forEach(function(button, index) {
        const buttonText = button.textContent.trim();
        button.addEventListener("keydown", function(event) {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            button.click();
          }
        });
      });
      
      return;
    }

    let radioLabels = form.querySelectorAll("label[for^='Gender__']");
    
    if (!radioLabels || radioLabels.length === 0) {
      radioLabels = document.querySelectorAll(`label[for^='Gender__'][for*='${formId}']`);
      
      if (!radioLabels || radioLabels.length === 0) {
        const allRadioInputs = document.querySelectorAll(`input[type="radio"][id*='${formId}']`);
        if (allRadioInputs && allRadioInputs.length > 0) {
          radioLabels = Array.from(allRadioInputs)
            .map(input => document.querySelector(`label[for='${input.id}']`))
            .filter(Boolean);
        }
      }
    }
    
    const allFormRadios = document.querySelectorAll(`input[type="radio"][id*='${formId}']`);
    
    allFormRadios.forEach(radio => {
      radio.setAttribute('tabindex', '-1');
    });
    
    const bothElements = [];
    const allElements = document.querySelectorAll(`[data-testid*='${formId}'] *`);
    allElements.forEach(el => {
      if (el.textContent && el.textContent.trim() === 'Both') {
        bothElements.push(el);
      }
    });
    
    if (radioLabels && radioLabels.length > 0) {
      const textToLabelMap = new Map();
      
      radioLabels.forEach((label, index) => {
        const optionText = label.querySelector('div')?.textContent || 'unknown';
        
        if (!textToLabelMap.has(optionText)) {
          textToLabelMap.set(optionText, label);
          
          label.setAttribute('tabindex', '0');
          
          label.addEventListener('focus', () => {
            label.style.outline = '2px solid black';
            label.style.outlineOffset = '2px';
          });
          
          label.addEventListener('blur', () => {
            label.style.outline = 'none';
          });
          
          if (formId === 'RqpFi9') {
            label.addEventListener('keydown', function(event) {
              if (event.key === " " || event.key === "Enter") {
                event.preventDefault();
                event.stopPropagation();
                
                const radioId = label.getAttribute('for');
                const radio = document.getElementById(radioId);
                if (radio && !radio.checked) {
                  label.setAttribute('data-retain-focus', 'true');
                  label.click();
                  setTimeout(() => {
                    label.setAttribute('data-retain-focus', 'false');
                  }, 10);
                }
              } else if (event.key === "ArrowRight" || event.key === "ArrowDown") {
                event.preventDefault();
                const nextIndex = (index + 1) % radioLabels.length;
                radioLabels[nextIndex].focus();
              } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
                event.preventDefault();
                const prevIndex = (index - 1 + radioLabels.length) % radioLabels.length;
                radioLabels[prevIndex].focus();
              }
            });
          } else {
            label.addEventListener('keydown', function(event) {
              if (event.key === " " || event.key === "Enter") {
                event.preventDefault();
                
                label.setAttribute('data-retain-focus', 'true');
                
                label.click();

                const radioId = label.getAttribute('for');
                const radio = document.getElementById(radioId);
                if (radio) {
                  radio.checked = true;
                  radio.dispatchEvent(new Event('change', { bubbles: true }));
                  radio.dispatchEvent(new Event('input', { bubbles: true }));
                }
                
                setTimeout(() => {
                  label.focus();
                  label.setAttribute('data-retain-focus', 'false');
                }, 10);
              } else if (event.key === "ArrowRight" || event.key === "ArrowDown") {
                event.preventDefault();
                const nextIndex = (index + 1) % radioLabels.length;
                radioLabels[nextIndex].focus();
                radioLabels[nextIndex].click();
              } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
                event.preventDefault();
                const prevIndex = (index - 1 + radioLabels.length) % radioLabels.length;
                radioLabels[prevIndex].focus();
                radioLabels[prevIndex].click();
              }
            });
          }
        } else {
          label.setAttribute('tabindex', '-1');
        }
      });
    }

    const formButtons = form.querySelectorAll("button");
    
    formButtons.forEach(function(button, index) {
      const buttonText = button.textContent.trim();
      button.addEventListener("keydown", function(event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          button.click();
        }
      });
    });

    const emailField = form.querySelector('input[type="email"]');
    if (emailField) {
      emailField.addEventListener('keydown', function(event) {
        if (event.key === "Enter") {
          event.preventDefault();
          let submitButton;
          
          if (formId === 'R9q9nz') {
            submitButton = Array.from(formButtons).find(btn => 
              btn.textContent.trim().toLowerCase().includes('sign up'));
          } else {
            submitButton = formButtons[0];
          }
          
          if (submitButton) {
            submitButton.click();
          }
        }
      });
    }

    if (formId === 'RqpFi9') {
    } else {
      const popupWrapper = form.closest('.klaviyo-form-wrapper') || form.parentElement;
      if (popupWrapper && formId === 'R9q9nz') {
        const emailField = form.querySelector('input[type="email"]');
        
        const radioLabelsArray = Array.from(radioLabels || []);
        
        const signUpButton = Array.from(formButtons).find(btn => 
          btn.textContent.trim().toLowerCase().includes('sign up'));
        const noThanksButton = Array.from(formButtons).find(btn => 
          btn.textContent.trim().toLowerCase().includes('no thanks'));
        
        const tabSequence = [
          emailField,
          ...radioLabelsArray,
          signUpButton,
          noThanksButton,
          closeButton
        ].filter(Boolean);
        
        if (tabSequence.length === 7) {
          const handleTabKey = function(event) {
            if (event.key !== 'Tab') return;
            
            if (!popupWrapper.offsetParent) return;
            
            const retainFocusElement = popupWrapper.querySelector('[data-retain-focus="true"]');
            if (retainFocusElement) {
              return;
            }
            
            const currentIndex = tabSequence.indexOf(document.activeElement);
            
            if (currentIndex !== -1) {
              let nextIndex;
              
              if (!event.shiftKey) {
                nextIndex = currentIndex === tabSequence.length - 1 ? 0 : currentIndex + 1;
              } else {
                nextIndex = currentIndex === 0 ? tabSequence.length - 1 : currentIndex - 1;
              }
              
              event.preventDefault();
              tabSequence[nextIndex].focus();
            } else {
              const anyFocusedInForm = Array.from(popupWrapper.querySelectorAll(':focus')).length > 0;
              
              if (!anyFocusedInForm) {
                event.preventDefault();
                tabSequence[0].focus();
              }
            }
          };
          
          document.removeEventListener('keydown', handleTabKey);
          document.addEventListener('keydown', handleTabKey);
          
          const handleEscapeKey = function(event) {
            if (event.key === "Escape" && closeButton) {
              closeButton.click();
            }
          };
          
          popupWrapper.removeEventListener('keydown', handleEscapeKey);
          popupWrapper.addEventListener('keydown', handleEscapeKey);
          
          if (emailField) {
            setTimeout(() => {
              emailField.focus();
            }, 100);
          }
        }
      }
    }
  }
  
  function getFocusableElements(container) {
    if (!container) return [];
    
    const elements = Array.from(container.querySelectorAll(
      'button, [href], input:not([type="radio"]), select, textarea, [tabindex]:not([tabindex="-1"]), [role="button"], label[tabindex="0"]'
    )).filter(el => {
      return el.offsetParent !== null;
    });
    
    const uniqueElements = [];
    const seenIds = new Set();
    const seenElements = new WeakSet();
    
    elements.forEach(el => {
      if (seenElements.has(el)) return;
      
      if (el.id && seenIds.has(el.id)) return;
      if (el.id) seenIds.add(el.id);
      
      if (el.tagName === 'INPUT' && el.type === 'radio') return;
      
      if (el.tagName === 'LABEL' && el.getAttribute('for')) {
        const inputId = el.getAttribute('for');
        if (seenIds.has(inputId)) return;
        seenIds.add(inputId);
      }
      
      seenElements.add(el);
      uniqueElements.push(el);
    });
    
    return uniqueElements;
  }
  
  initKlaviyoFormAccessibility();
  initBackInStockAccessibility();
});

function initBackInStockAccessibility() {
  function watchForBISModal() {
    const existingIframe = document.getElementById('klaviyo-bis-iframe');
    if (existingIframe) {
      setupBISIframeAccessibility(existingIframe);
      
      const styleObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'style') {
            const isVisible = existingIframe.style.display !== 'none';
            
            if (isVisible) {
              existingIframe.removeAttribute('data-accessibility-processed');
              setupBISIframeAccessibility(existingIframe);
            }
          }
        });
      });
      
      styleObserver.observe(existingIframe, { attributes: true, attributeFilter: ['style'] });
      return;
    }
    
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          for (let i = 0; i < mutation.addedNodes.length; i++) {
            const node = mutation.addedNodes[i];
            if (node.id === 'klaviyo-bis-iframe' || (node.querySelector && node.querySelector('#klaviyo-bis-iframe'))) {
              const iframe = node.id === 'klaviyo-bis-iframe' ? node : node.querySelector('#klaviyo-bis-iframe');
              if (iframe) {
                setupBISIframeAccessibility(iframe);
                
                const styleObserver = new MutationObserver(function(styleMutations) {
                  styleMutations.forEach(function(styleMutation) {
                    if (styleMutation.attributeName === 'style') {
                      const isVisible = iframe.style.display !== 'none';
                      
                      if (isVisible) {
                        iframe.removeAttribute('data-accessibility-processed');
                        setupBISIframeAccessibility(iframe);
                      }
                    }
                  });
                });
                
                styleObserver.observe(iframe, { attributes: true, attributeFilter: ['style'] });
              }
            }
          }
        }
      });
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
  }
  
  function setupBISIframeAccessibility(iframe) {
    if (!iframe) return;
    
    if (iframe.style.display === 'none') return;
    
    if (iframe.getAttribute('data-accessibility-processed') === 'true') return;
    
    iframe.setAttribute('data-accessibility-processed', 'true');
    
    const previousActiveElement = document.activeElement;
    
    if (!iframe.hasAttribute('tabindex')) {
      iframe.setAttribute('tabindex', '0');
    }
    
    const handleOutsideTab = function(event) {
      if (event.key === 'Tab' && iframe.style.display !== 'none') {
        event.preventDefault();
        iframe.focus();
      }
    };
    
    document.removeEventListener('keydown', handleOutsideTab);
    document.addEventListener('keydown', handleOutsideTab);
    
    const checkVisibility = function() {
      if (iframe.style.display === 'none') {
        document.removeEventListener('keydown', handleOutsideTab);
        clearInterval(visibilityCheckInterval);
        if (previousActiveElement) {
          previousActiveElement.focus();
        }
      }
    };
    
    const visibilityCheckInterval = setInterval(checkVisibility, 500);
    
    setTimeout(() => {
      iframe.focus();
    }, 300);
    
    try {
      setTimeout(() => {
        try {
          const iframeDoc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
          
          if (iframeDoc) {
            if (iframeDoc.readyState === 'complete') {
              enhanceIframeContent(iframeDoc, iframe);
            } else {
              iframe.addEventListener('load', function() {
                enhanceIframeContent(iframeDoc, iframe);
              });
            }
          }
        } catch (innerError) {
          setupFallbackAccessibility(iframe);
        }
      }, 500);
    } catch (error) {
      setupFallbackAccessibility(iframe);
    }
  }
  
  function setupFallbackAccessibility(iframe) {
    document.addEventListener('keydown', function handleEscape(event) {
      if (!iframe || iframe.style.display === 'none' || document.getElementById('klaviyo-bis-iframe') === null) {
        document.removeEventListener('keydown', handleEscape);
        return;
      }
      
      if (event.key === 'Escape') {
        const closeButtons = document.querySelectorAll('.klaviyo-close-form, .close-bis, [data-bis-close], .klaviyo-bis-close');
        if (closeButtons.length > 0) {
          closeButtons[0].click();
        }
        
        if (iframe.style.display !== 'none') {
          iframe.style.display = 'none';
        }
      }
    });
  }
  
  function enhanceIframeContent(iframeDoc, iframe) {
    if (!iframeDoc) return;
    
    const bisModal = iframeDoc.getElementById('klaviyo-bis-modal');
    if (!bisModal) {
      const modals = iframeDoc.querySelectorAll('.modal, [role="dialog"]');
      if (modals.length > 0) {
        enhanceModalInIframe(iframeDoc, modals[0], iframe);
      } else {
        setupIframeKeyboardNavigation(iframeDoc);
      }
      return;
    }
    
    enhanceModalInIframe(iframeDoc, bisModal, iframe);
  }
  
  function enhanceModalInIframe(iframeDoc, modal, iframe) {
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    
    iframeDoc.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        const closeButton = iframeDoc.querySelector('.klaviyo-bis-close, .close, .close-bis');
        if (closeButton) {
          event.preventDefault();
          event.stopPropagation();
          closeButton.click();
          return;
        }
      }
      
      if (event.key === 'Enter') {
        event.stopPropagation();
        
        const activeElement = iframeDoc.activeElement;
        const tagName = activeElement.tagName.toLowerCase();
        
        if (tagName === 'select') {
          event.preventDefault();
          
          try {
            activeElement.click();
            
            setTimeout(() => {
              ['mousedown', 'mouseup', 'click'].forEach(eventType => {
                const mouseEvent = new MouseEvent(eventType, {
                  bubbles: true,
                  cancelable: true,
                  view: iframe.contentWindow || window
                });
                activeElement.dispatchEvent(mouseEvent);
              });
              
              setTimeout(() => {
                if (activeElement.options && activeElement.options.length > 0) {
                  const nextIndex = (activeElement.selectedIndex + 1) % activeElement.options.length;
                  activeElement.selectedIndex = nextIndex;
                  activeElement.dispatchEvent(new Event('change', { bubbles: true }));
                }
              }, 100);
            }, 50);
          } catch (e) { }
        }
        else if (tagName === 'input') {
          const type = activeElement.type.toLowerCase();
          
          if (type === 'checkbox') {
            event.preventDefault();
            activeElement.checked = !activeElement.checked;
            activeElement.dispatchEvent(new Event('change', { bubbles: true }));
          }
          else if (type === 'email' || type === 'text') {
            const submitButton = iframeDoc.querySelector('button[type="submit"], .btn-success, .klaviyo-bis-trigger-submit');
            if (submitButton) {
              event.preventDefault();
              submitButton.click();
            }
          }
        }
        else if (tagName === 'button') {
          if (!activeElement.classList.contains('klaviyo-bis-close') && 
              !activeElement.classList.contains('close-bis')) {
            event.preventDefault();
            
            setTimeout(() => {
              activeElement.click();
            }, 10);
          }
        }
        else if (tagName === 'div' && activeElement.getAttribute('role') === 'button') {
          event.preventDefault();
          activeElement.click();
        }
        else if (tagName === 'label') {
          event.preventDefault();
          
          const forId = activeElement.getAttribute('for');
          if (forId) {
            const associatedInput = iframeDoc.getElementById(forId);
            if (associatedInput && associatedInput.type === 'checkbox') {
              associatedInput.checked = !associatedInput.checked;
              associatedInput.dispatchEvent(new Event('change', { bubbles: true }));
            } else if (associatedInput) {
              associatedInput.click();
            }
          } else {
            activeElement.click();
          }
        }
      }
    });
    
    const makeElementAccessible = (element, role, label) => {
      if (!element) return;
      
      if (!element.hasAttribute('tabindex')) {
        element.setAttribute('tabindex', '0');
      }
      
      if (role && !element.hasAttribute('role')) {
        element.setAttribute('role', role);
      }
      
      if (label && !element.hasAttribute('aria-label')) {
        element.setAttribute('aria-label', label);
      }
      
      element.addEventListener('focus', () => {
        element.style.outline = '2px solid black';
        element.style.outlineOffset = '2px';
      });
      
      element.addEventListener('blur', () => {
        element.style.outline = '';
      });
    };
    
    const variantSelect = iframeDoc.querySelector('#variants, select');
    const emailField = iframeDoc.querySelector('#email, input[type="email"]');
    const newsletterCheckbox = iframeDoc.querySelector('#subscribe_for_newsletter, input[type="checkbox"]');
    const newsletterLabel = newsletterCheckbox ? 
                           iframeDoc.querySelector(`label[for="${newsletterCheckbox.id}"]`) : 
                           iframeDoc.querySelector('label');
    const submitButton = iframeDoc.querySelector('button[type="submit"], .btn-success');
    
    const closeButton = iframeDoc.querySelector('button.klaviyo-bis-close, button.close[data-dismiss="modal"]');
    
    if (closeButton) {
      makeElementAccessible(closeButton, 'button', 'Close notification dialog');
      
      closeButton.setAttribute('tabindex', '0');
      
      const parent = closeButton.parentNode;
      if (parent) {
        parent.appendChild(closeButton);
      }
    }
    
    const closeLink = iframeDoc.querySelector('#completed_message a.klaviyo-bis-close');
    if (closeLink) {
      makeElementAccessible(closeLink, 'button', 'Close notification dialog');
    }
    
    if (variantSelect) {
      makeElementAccessible(variantSelect, 'combobox', 'Select product variant');
      
      const dropdownContainer = variantSelect.parentElement;
      if (dropdownContainer) {
        const customDropdown = dropdownContainer.querySelector('.dropdown-toggle, .select-button');
        if (customDropdown) {
          makeElementAccessible(customDropdown, 'button', 'Open dropdown menu');
        }
      }
    }
    
    if (emailField) {
      makeElementAccessible(emailField, 'textbox', 'Email address for notification');
    }
    
    if (newsletterCheckbox) {
      makeElementAccessible(newsletterCheckbox, 'checkbox', 'Subscribe to newsletter');
    }
    
    if (newsletterLabel) {
      if (newsletterCheckbox) {
        newsletterLabel.setAttribute('tabindex', '-1');
      } else {
        makeElementAccessible(newsletterLabel, 'button', 'Toggle newsletter subscription');
      }
      
      newsletterLabel.addEventListener('click', () => {
        if (newsletterCheckbox) {
          newsletterCheckbox.click();
        }
      });
      
      newsletterLabel.addEventListener('focus', () => {
        newsletterLabel.style.outline = '2px solid black';
        newsletterLabel.style.outlineOffset = '2px';
      });
      
      newsletterLabel.addEventListener('blur', () => {
        newsletterLabel.style.outline = '';
      });
    }
    
    if (submitButton) {
      makeElementAccessible(submitButton, 'button', 'Notify me when back in stock');
    }
    
    const focusableElements = [
      variantSelect,
      emailField,
      newsletterCheckbox,
      submitButton,
      closeButton,
      closeLink
    ].filter(Boolean);
    
    if (closeButton && !focusableElements.includes(closeButton)) {
      focusableElements.push(closeButton);
    }
    
    if (closeLink && !focusableElements.includes(closeLink)) {
      focusableElements.push(closeLink);
    }
    
    setupFocusTrapInIframe(iframeDoc, modal, focusableElements);
    
    setTimeout(() => {
      if (variantSelect) {
        variantSelect.focus();
      } else if (emailField) {
        emailField.focus();
      }
    }, 500);
  }
  
  function getAllFocusableElements(doc) {
    return Array.from(
      doc.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), [role="button"]')
    ).filter(el => {
      return el.offsetParent !== null && !el.disabled;
    });
  }
  
  function setupIframeKeyboardNavigation(iframeDoc) {
    if (!iframeDoc) return;
    
    iframeDoc.addEventListener('keydown', function(event) {
      const activeElement = iframeDoc.activeElement;
      
      if (event.key === 'Enter' || event.key === ' ') {
        if (activeElement.tagName === 'BUTTON' || 
            activeElement.tagName === 'A' || 
            activeElement.tagName === 'INPUT' && activeElement.type === 'checkbox' ||
            activeElement.tagName === 'LABEL' && activeElement.htmlFor) {
          
          if (activeElement.tagName === 'LABEL' && activeElement.htmlFor) {
            const associatedInput = iframeDoc.getElementById(activeElement.htmlFor);
            if (associatedInput) {
              event.preventDefault();
              associatedInput.click();
            }
          }
          else if (event.key === ' ' && activeElement.tagName !== 'INPUT') {
            event.preventDefault();
            activeElement.click();
          }
        }
        else if (event.key === 'Enter' && activeElement.tagName === 'INPUT') {
          const form = activeElement.closest('form');
          const submitButton = form ? form.querySelector('button[type="submit"], input[type="submit"], .btn-success') : null;
          
          if (submitButton) {
            event.preventDefault();
            submitButton.click();
          }
        }
      }
      else if (event.key === 'Escape') {
        const closeButton = iframeDoc.querySelector('.klaviyo-bis-close, .close, .close-bis, [aria-label="Close"]');
        if (closeButton) {
          event.preventDefault();
          closeButton.click();
        }
      }
    });
  }
  
  function setupFocusTrapInIframe(iframeDoc, modal, customElements) {
    if (!iframeDoc || !modal) return;
    
    let focusableElements;
    if (customElements && customElements.length) {
      focusableElements = customElements;
    } else {
      focusableElements = Array.from(modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'));
    }
    
    if (focusableElements.length === 0) {
      return;
    }
    
    focusableElements.forEach(el => {
      if (!el.hasAttribute('tabindex')) {
        el.setAttribute('tabindex', '0');
      }
    });
    
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];
    
    const closeButton = iframeDoc.querySelector('button.klaviyo-bis-close, button.close[data-dismiss="modal"]');
    const closeButtonIndex = closeButton ? focusableElements.indexOf(closeButton) : -1;
    
    const handleTabKey = function(event) {
      if (event.key !== 'Tab') return;
      
      const currentElement = iframeDoc.activeElement;
      const currentIndex = focusableElements.indexOf(currentElement);
      
      if (!event.shiftKey && (iframeDoc.activeElement === lastFocusableElement || currentIndex === focusableElements.length - 1 || currentIndex === closeButtonIndex)) {
        event.preventDefault();
        firstFocusableElement.focus();
        return;
      } 
      else if (event.shiftKey && (iframeDoc.activeElement === firstFocusableElement || currentIndex === 0)) {
        event.preventDefault();
        lastFocusableElement.focus();
        return;
      }
      else if (currentIndex === -1) {
        event.preventDefault();
        if (event.shiftKey) {
          lastFocusableElement.focus();
        } else {
          firstFocusableElement.focus();
        }
      }
    };
    
    if (iframeDoc._tabHandler) {
      iframeDoc.removeEventListener('keydown', iframeDoc._tabHandler);
    }
    
    iframeDoc._tabHandler = handleTabKey;
    
    iframeDoc.addEventListener('keydown', handleTabKey);
  }
  
  watchForBISModal();
}

function findAssociatedRadio(label, allInputs) {
  if (label.hasAttribute('for')) {
    const forId = label.getAttribute('for');
    const radio = document.getElementById(forId);
    if (radio) return radio;
  }
  
  const labelRect = label.getBoundingClientRect();
  let closestInput = null;
  let closestDistance = Infinity;
  
  allInputs.forEach(input => {
    const inputRect = input.getBoundingClientRect();
    const dx = (labelRect.left + labelRect.width/2) - (inputRect.left + inputRect.width/2);
    const dy = (labelRect.top + labelRect.height/2) - (inputRect.top + inputRect.height/2);
    const distance = Math.sqrt(dx*dx + dy*dy);
    
    if (distance < closestDistance) {
      closestDistance = distance;
      closestInput = input;
    }
  });
  
  if (closestInput && closestDistance < 100) {
    return closestInput;
  }
  
  return null;
}
// End: Klaviyo Form Keyboard Accessibility

// Start: Klaviyo form autocomplete and accessibility fixes
(function addGenderAutocomplete () {
  const apply = () => {
    document.querySelectorAll('input[type="radio"][name^="Gender__"]:not([autocomplete])')
      .forEach(el => el.setAttribute('autocomplete', 'sex'));
    
    // Fix accessibility: Add aria-labels to radio buttons that lack accessible names
    document.querySelectorAll('input[type="radio"][name^="Gender__"]').forEach(radio => {
      if (!radio.hasAttribute('aria-label') && !radio.hasAttribute('aria-labelledby')) {
        const associatedLabel = document.querySelector(`label[for='${radio.id}']`);
        if (associatedLabel) {
          // Get the text content from the div inside the label
          const labelDiv = associatedLabel.querySelector('div');
          const labelText = labelDiv ? labelDiv.textContent.trim() : associatedLabel.textContent.trim();
          if (labelText) {
            radio.setAttribute('aria-label', labelText);
          }
        }
      }
    });
    
    // Fix accessibility: Add aria-label to fieldset if it lacks accessible name
    document.querySelectorAll('fieldset[aria-required="true"]').forEach(fieldset => {
      if (!fieldset.hasAttribute('aria-label') && !fieldset.hasAttribute('aria-labelledby')) {
        const radiogroup = fieldset.querySelector('[role="radiogroup"]');
        if (radiogroup) {
          fieldset.setAttribute('aria-label', 'Gender preference');
        }
      }
    });
    
    // Fix accessibility: Remove role="radiogroup" and restore native radio accessibility
    document.querySelectorAll('[role="radiogroup"]').forEach(radiogroup => {
      // Remove the role="radiogroup" to avoid conflicts with native radio inputs
      radiogroup.removeAttribute('role');
      radiogroup.removeAttribute('aria-label');
      radiogroup.removeAttribute('aria-required');
      
      // Restore native radio inputs to be accessible
      const nativeRadios = radiogroup.querySelectorAll('input[type="radio"]');
      nativeRadios.forEach(radio => {
        radio.removeAttribute('aria-hidden');
        radio.setAttribute('tabindex', '0');
      });
      
      // Remove role="radio" from labels since we're using native radio inputs
      const radioLabels = radiogroup.querySelectorAll('label[role="radio"]');
      radioLabels.forEach(label => {
        label.removeAttribute('role');
        label.removeAttribute('aria-checked');
        label.removeAttribute('data-aria-checked-listener');
        label.setAttribute('tabindex', '-1');
      });
    });
    
    // Fix accessibility: Add aria-checked to labels with role="radio"
    document.querySelectorAll('label[role="radio"]').forEach(label => {
      if (!label.hasAttribute('aria-checked')) {
        // Check if the associated radio input is checked
        const radioId = label.getAttribute('for');
        const radioInput = document.getElementById(radioId);
        const isChecked = radioInput ? radioInput.checked : false;
        label.setAttribute('aria-checked', isChecked.toString());
      }
      
      // Add event listener to update aria-checked when radio state changes
      const radioId = label.getAttribute('for');
      const radioInput = document.getElementById(radioId);
      if (radioInput && !label.hasAttribute('data-aria-checked-listener')) {
        label.setAttribute('data-aria-checked-listener', 'true');
        
        const updateAriaChecked = () => {
          label.setAttribute('aria-checked', radioInput.checked.toString());
        };
        
        radioInput.addEventListener('change', updateAriaChecked);
        radioInput.addEventListener('click', updateAriaChecked);
        
        // Also listen for clicks on the label itself
        label.addEventListener('click', () => {
          setTimeout(updateAriaChecked, 10);
        });
      }
    });
  };
  apply();

  const observer = new MutationObserver(apply);
  observer.observe(document.body, { childList: true, subtree: true });
})();

// Start: Klaviyo phone number input combobox accessibility fix
(function fixKlaviyoPhoneComboboxAccessibility() {
  const apply = () => {
    // Find combobox buttons in Klaviyo forms and add missing aria-controls
    const comboboxButtons = document.querySelectorAll('button[role="combobox"]');
    
    comboboxButtons.forEach(button => {
      if (!button.hasAttribute('aria-controls')) {
        // Generate a unique ID for the listbox
        const listboxId = 'klaviyo-listbox-' + Math.random().toString(36).substr(2, 9);
        button.setAttribute('aria-controls', listboxId);
      }
    });
  };
  
  // Apply immediately and watch for new elements
  apply();
  
  const observer = new MutationObserver(apply);
  observer.observe(document.body, { childList: true, subtree: true });
})();
// End: Klaviyo phone number input combobox accessibility fix

// Start: Product count display -- debugs
(function () {
  function updateActualProductCount() {
    const productItems = document.querySelectorAll('.product-item');
    const productGridEl = document.querySelector('.product-grid');

    window.devLog('Loaded products count:', productItems.length);
    window.devLog('Loaded products + inline media count:', productGridEl.children.length);
  }

  function debounce(func, wait = 1000) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    const collectionLoop = document.querySelector('#CollectionLoop, #SearchLoop');
    if (collectionLoop) {
      const observer = new MutationObserver(
        debounce(function (mutations) {
          updateActualProductCount();
        }, 3000)
      );

      observer.observe(collectionLoop, {
        childList: true,
        subtree: true
      });
    }
  });
})();
// End: Product count display -- debugs


// Start: Setup debug_mode from URL param
(function () {
  const params = new URLSearchParams(window.location.search);
  if (params.has('debug_mode')) {
    const value = params.get('debug_mode');
    if (value === 'true') {
      localStorage.setItem('debug_mode', 'true');
    } else if (value === 'false') {
      localStorage.removeItem('debug_mode');
    }
  }
})();

// React to zoom changes where supported
if (window.visualViewport) {
  const __pdpZoomHandler = () => {
    try { window.requestAnimationFrame(() => { applyPdpZoomImageHeightFix && applyPdpZoomImageHeightFix(); }); } catch(e) {}
  };
  window.visualViewport.addEventListener('resize', __pdpZoomHandler);
  window.visualViewport.addEventListener('scroll', __pdpZoomHandler);
}

window.devLog = function (...args) {
  if (localStorage.getItem('debug_mode') === 'true') {
    console.log('#', ...args);
  }
};
// End: Setup debug_mode from URL param

(function(){
  // A11Y: Quick Add variant selection announcements
  document.addEventListener('change', function(e){
    const input = e.target;
    if (input && input.matches('.quick-add-form input[type="radio"][data-single-option-selector]')) {
      const form = input.closest('.quick-add-form');
      const status = form && form.querySelector('[data-quick-add-status]');
      const optionName = input.getAttribute('name').replace(/^options\[|\]$/g, '');
      const value = input.value;
      const message = `${optionName} ${value} selected`;
      if (status) status.textContent = message;
      const global = document.getElementById('a11y-status');
      if (global) global.textContent = message;
    }
  }, true);

  // A11Y: Quick Add success announcement via theme:product:add
  document.addEventListener('theme:product:add', function(e){
    try {
      const response = e.detail && e.detail.response;
      if (!response) return;
      const title = response.title || 'Item';
      const qty = response.quantity || 1;
      const message = `${title} added to cart. Quantity ${qty}.`;
      const form = e.detail.button && e.detail.button.closest('.quick-add-form');
      const status = form && form.querySelector('[data-quick-add-status]');
      if (status) status.textContent = message;
      const global = document.getElementById('a11y-status');
      if (global) global.textContent = message;
    } catch(err) {}
  });

  // A11Y: Localization form announcement
  document.addEventListener('submit', function(e){
    const form = e.target;
    if (form && form.id === 'localization_form') {
      const lang = (form.querySelector('#CustomerHubLanguageCodeSelector') || {}).value || '';
      const country = (form.querySelector('#CustomerHubCountryCodeSelector') || {}).value || '';
      const msg = `Region updated to ${country || 'selected country'}, Language ${lang || 'selected language'}`;
      try {
        sessionStorage.setItem('a11yLocalizationMsg', msg);
      } catch (e) {}
      const global = document.getElementById('a11y-status');
      if (global) global.textContent = msg;
    }
  }, true);

  // After navigation, announce localization change if stored
  try {
    const pending = sessionStorage.getItem('a11yLocalizationMsg');
    if (pending) {
      const global = document.getElementById('a11y-status');
      if (global) global.textContent = pending;
      sessionStorage.removeItem('a11yLocalizationMsg');
    }
  } catch (e) {}

  // A11Y: Klaviyo form success/error announcements (delegated)
  document.addEventListener('click', function(e){
    const el = e.target;
    const formWrapper = el.closest('.klaviyo-form');
    if (!formWrapper) return;
    setTimeout(function(){
      const statusEl = document.getElementById('klaviyo-status');
      const success = formWrapper.querySelector('[class*="success" i], [data-testid="form-success"]');
      const error = formWrapper.querySelector('[class*="error" i], [data-testid="form-error"]');
      if (success && statusEl) statusEl.textContent = 'Subscribed successfully.';
      if (error) {
        if (statusEl) statusEl.textContent = 'Error: invalid email.';
        const alertEl = document.getElementById('a11y-alert');
        if (alertEl) alertEl.textContent = 'Error: invalid email.';
      }
    }, 500);
  }, true);
})();

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.shg-gallery-thumb-image:not([alt])')
    .forEach(function(img){ img.setAttribute('alt', ''); });
});

(function(){
  var applyShogunThumbAlt = function(){
    document.querySelectorAll('.shg-gallery-thumb-image:not([alt])')
      .forEach(function(img){ img.setAttribute('alt', ''); });
  };
  var shogunObserver = new MutationObserver(function(mutations){
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'childList' && m.addedNodes && m.addedNodes.length) {
        applyShogunThumbAlt();
        break;
      }
    }
  });
  try {
    shogunObserver.observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();

// Iframe accessible names
document.addEventListener('DOMContentLoaded', function () {
  var loop = document.getElementById('customer-portal');
  if (loop && !loop.hasAttribute('title')) {
    loop.setAttribute('title', 'Customer returns portal');
  }

  var preview = document.getElementById('PBarNextFrame');
  if (preview && !preview.hasAttribute('title')) {
    preview.setAttribute('title', 'Shopify preview bar');
  }
});

// Gorgias chat: add landmark and hide non-interactive wrappers
(function(){
  function labelGorgias() {
    var chat = document.getElementById('gorgias-chat-container');
    if (chat) {
      if (!chat.hasAttribute('role')) chat.setAttribute('role', 'complementary');
      if (!chat.hasAttribute('aria-label')) chat.setAttribute('aria-label', 'Live chat');
    }
    document.querySelectorAll('.gorgias-chat-key-62nneq').forEach(function(div){
      if (!div.querySelector('iframe')) div.setAttribute('aria-hidden', 'true');
    });
  }

  document.addEventListener('DOMContentLoaded', labelGorgias);
  try {
    new MutationObserver(labelGorgias).observe(document.body, { childList: true, subtree: true });
  } catch(e) {}
})();